import { LoadingButton } from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Dialog,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  Paper,
  SvgIcon,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import {
  colorDisableGrey,
  colorLinkGrey,
  colorPrimary,
  colorSecondary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import CustomTabLabel from '../../custom/CustomTabLabel';
import {
  createTitle,
  getOptionLabel,
  handleError,
  isArrayNotEmpty
} from '../../utils/utils';
import { useSelector } from 'react-redux';
import { Close, CloseOutlined, MoreHoriz } from '@mui/icons-material';
import { UploadIcon } from '../../utils/iconSvg';
import { useDispatch } from 'react-redux';
import {
  addNewContent,
  deleteQuestions,
  getContentById,
  getSectionList,
  getTagList,
  publishContent,
  revertAllAddContentData,
  revertPublishContent,
  updateContent,
  updateContentResponses,
  updateContentSettings
} from '../../redux/reducers/contentSlice';
import {
  getNoAuthGradeList,
  getThemeList,
  getMediumList,
  getUnitsByGrade,
  addNewMedium
} from '../../redux/reducers/mastersSlice';
import AddNewTagModal from './components/AddNewTagModal';
import AddNewMediumModal from './components/AddNewMediumModal';
import AddNewSectionModal from './components/AddNewSectionModal';
import SnackBarBox from '../../components/SnackBarBox';
import { FLASHCARD_ICON, IMG_PDF_PREVIEW } from '../../utils/imageUrls';
import CustomPagination from '../../components/CustomTablePagination';
import AddNewQuestions from './components/AddNewQuestions';
import ConfirmBox from '../../components/ConfirmBox';
import { IOSSwitch } from '../../utils/styledLayout';
import CustomAccordion from './components/CustomAccordion';
import * as pdfjsLib from 'pdfjs-dist/webpack';
import AddQuizInVideo from './AddQuizInVideo';
import { setGamificationDetails } from '../../config/cookie';
import {
  ALLOWED_CONTENT_TYPE_OPTIONS,
  mapContentTypeToApi,
  mapContentTypeToFormOption,
  normalizeContentPublishStatus
} from '../../utils/navigationMenu';

const RESPONSE_INTERACTION_FIELDS = {
  1: 'likes',
  2: 'comments',
  3: 'share',
  4: 'download'
};

const CONTENT_FILE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.mp3',
  '.wav',
  '.ogg',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx'
];

const PDF_MIME_TYPES = ['application/pdf', 'application/x-pdf'];

const isPdfFile = file => {
  if (!file) {
    return false;
  }

  const fileName = file.name?.toLowerCase() || '';
  return fileName.endsWith('.pdf') || PDF_MIME_TYPES.includes(file.type || '');
};

const isBrowserFile = value =>
  typeof File !== 'undefined' && value instanceof File;

const getSecondPdfFromContent = details => {
  if (!details) {
    return { url: null, name: '' };
  }

  return {
    url:
      details.contentFileUrl2 ||
      details.contentFile2Url ||
      details.additionalContentFileUrl ||
      details.secondContentFileUrl ||
      null,
    name:
      details.contentFileName2 ||
      details.contentFile2Name ||
      details.additionalContentFileName ||
      details.secondContentFileName ||
      ''
  };
};

const CONTENT_FILE_ACCEPT = [
  ...CONTENT_FILE_EXTENSIONS,
  ...PDF_MIME_TYPES
].join(',');
const PDF_FILE_ACCEPT = ['.pdf', ...PDF_MIME_TYPES].join(',');
const MAX_CONTENT_FILE_SIZE_BYTES = 1 * 1024 * 1024 * 1024;

const getUploadTypeFromFileName = fileName => {
  const name = fileName.toLowerCase();

  if (
    name.endsWith('.mp4') ||
    name.endsWith('.mov') ||
    name.endsWith('.avi') ||
    name.endsWith('.mkv')
  ) {
    return 'Video';
  }
  if (name.endsWith('.mp3') || name.endsWith('.wav') || name.endsWith('.ogg')) {
    return 'Audio';
  }
  if (
    name.endsWith('.png') ||
    name.endsWith('.jpg') ||
    name.endsWith('.jpeg') ||
    name.endsWith('.gif')
  ) {
    return 'Image';
  }
  if (name.endsWith('.pdf')) {
    return 'PDF';
  }
  if (name.endsWith('.doc') || name.endsWith('.docx')) {
    return 'MSWORD';
  }
  if (name.endsWith('.ppt') || name.endsWith('.pptx')) {
    return 'POWERPOINT';
  }
  if (name.endsWith('.xlsx') || name.endsWith('.xls')) {
    return 'EXCEL';
  }
  return '';
};

const AddNewContents = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    sectionList,
    tagList,
    isAddNewContentSuccess,
    isAddNewContentLoading,
    isAddNewContentFailed,
    addNewContentErrorContainer,
    addContentResponse,
    contentDetails,
    isUpadteContentResponsesSuccess,
    isUpadteContentResponsesLoading,
    updateContentSettingsResponse,
    isUpadteContentSettingsSuccess,
    isUpadteContentSettingsLoading,
    isUpadteContentLoading,
    isUpadteContentSuccess,
    isUpadteContentFailed,
    upadteContentErrorContainer,
    isAddNewTagLoading,
    isAddNewTagSuccess,
    isAddNewTagFailed,
    addNewTagErrorContainer,
    addTagResponse,
    isAddNewSectionLoading,
    isAddNewSectionSuccess,
    isAddNewSectionFailed,
    addNewSectionErrorContainer,
    addSectionResponse,
    isPublishContentLoading,
    isPublishContentSuccess,
    publishContentResponse,
    isSaveFlashCardLoading,
    isSaveFlashCardSuccess,
    flashCardErrorContainer,
    isSaveFlashCardFailed,
    flashCardResponse,
    isDeleteQuestionLoading,
    isDeleteQuestionSuccess,
    deleteQuestionResponse,
    isDeleteQuestionFailed,
    deleteQuestionErrorContainer,
    isAddNewQuizLoading,
    isAddNewQuizSuccess,
    isAddNewQuizFailed,
    addNewQuizResponse,
    addNewQuizErrorContainer,
    isDeleteQuizSuccess,
    isDeleteQuizLoading,
    isDeleteQuizFailed,
    deleteQuizResponse,
    deleteQuizErrorContainer
  } = useSelector(state => state.content);
  const {
    noAuthGradeList,
    themeList,
    mediumList,
    unitList,
    isAddNewMediumLoading,
    isAddNewMediumSuccess,
    isAddNewMediumFailed,
    addNewMediumErrorContainer,
    addMediumResponse
  } = useSelector(state => state.masters);

  const { authData } = useSelector(state => state.auth);
  const [initialValues, setInitalValues] = useState({
    tabValue: location?.state?.tabValue || 0,
    page: 0,
    size: 10,
    searchFilter: ''
  });
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [progress, setProgress] = useState(0);
  const [contentId, setContentId] = useState(0);
  const [isHover, setIshover] = useState(false);
  const [isNewTagModalOpen, setIsNewTagModalOpen] = useState(false);
  const [isNewMediumModalOpen, setIsNewMediumModalOpen] = useState(false);
  const [isNewSectionModalOpen, setIsNewSectionModalOpen] = useState(false);
  const [isNewQuestionModalOpen, setIsNewQuestionModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [showError, setShowError] = useState(false);
  const [page, setPage] = useState(0);
  const [questionList, setQuestionList] = useState([]);
  const [editQuestionData, setEditQuestionData] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState('');
  const [contentStatus, setContentStatus] = useState('');
  const [encryptedId, setEncryptedId] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [gamificationData, setGamificationData] = useState({});
  const userId = authData?.userId || 0;

  // Local state to save theme/medium/unit values and prevent auto-refresh
  const [savedThemeValue, setSavedThemeValue] = useState(null);
  const [savedMediumValue, setSavedMediumValue] = useState(null);
  const [savedUnitValue, setSavedUnitValue] = useState(null);
  const [isThemeMediumUnitPopulated, setIsThemeMediumUnitPopulated] =
    useState(false);

  const [fileDuration, setFileDuration] = useState('');
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailFileName, setThumbnailFileName] = useState('');
  const [thumbnailProgress, setThumbnailProgress] = useState(0);
  const thumbnailSourceRef = useRef('none');
  const pdfThumbRequestIdRef = useRef(0);
  const [secondFile, setSecondFile] = useState(null);
  const [secondFileName, setSecondFileName] = useState('');
  const [secondFileProgress, setSecondFileProgress] = useState(0);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const defaultAudioSvg = '/images/default-audio.svg';
  const defaultExcelSvg = '/images/default-excel.svg';
  const defaultWordSvg = '/images/default-word.svg';
  const defaultPowerPointSvg = '/images/default-powerpoint.svg';

  // For Edit Page

  useEffect(() => {
    dispatch(revertPublishContent());
  }, []);

  useEffect(() => {
    if (
      location.pathname === '/content-management/edit-content' &&
      location.state
    ) {
      let encryptId = location.state?.encryptedContentId;
      setEncryptedId(encryptId);
      dispatch(getContentById({ encryptId, userId }));

      localStorage.setItem('localContentId', location.state?.contentId);
    }
    setContentId(location.state?.contentId || contentDetails?.contentId || 0);
  }, [
    isUpadteContentSuccess,
    isUpadteContentResponsesSuccess,
    isUpadteContentSettingsSuccess,
    isAddNewQuizSuccess,
    isDeleteQuizSuccess
  ]);

  useEffect(() => {
    if (
      isAddNewQuizSuccess &&
      !isAddNewQuizLoading &&
      location.pathname === '/content-management/add-new-content'
    ) {
      let encryptId = encryptedId;
      dispatch(getContentById({ encryptId, userId }));
    }
  }, [isAddNewQuizSuccess, isAddNewQuizLoading, isDeleteQuizSuccess]);

  // Call Get API After content (Overview) is Created

  useEffect(() => {
    if (
      isAddNewContentSuccess &&
      addContentResponse &&
      initialValues.tabValue === 0
    ) {
      const newContentId =
        addContentResponse?.payload?.id ||
        addContentResponse?.payload?.contentId ||
        addContentResponse?.id ||
        addContentResponse?.contentId;
      const encryptId =
        addContentResponse?.payload?.encryptedContentId ||
        addContentResponse?.encryptedContentId;
      setEncryptedId(encryptId);
      if (encryptId) {
        dispatch(getContentById({ encryptId, userId }));
      }
      if (newContentId) {
        setContentId(newContentId);
        localStorage.setItem('localContentId', newContentId);
      }

      // Quiz in Video Condition apply here

      if (addContentResponse?.payload?.uploadType !== 'Video') {
        setInitalValues({
          ...initialValues,
          tabValue: 1
        });
      }
    }
  }, [isAddNewContentSuccess]);

  useEffect(() => {
    if (
      !isUpadteContentLoading &&
      isUpadteContentSuccess &&
      initialValues.tabValue === 0
    ) {
      setInitalValues({
        ...initialValues,
        tabValue: 1
      });
      setContentId(
        addContentResponse?.payload?.id ||
          addContentResponse?.id ||
          location.state?.contentId ||
          Number(localStorage.getItem('localContentId')) ||
          0
      );
    } else if (
      !isUpadteContentSettingsLoading &&
      isUpadteContentSettingsSuccess &&
      initialValues.tabValue === 2
    ) {
      setContentId(
        localStorage.getItem('localContentId') ||
          addContentResponse?.id ||
          location.state?.contentId
      );
      setInitalValues({
        ...initialValues,
        tabValue: 2
      });
    }
  }, [
    isUpadteContentResponsesSuccess,
    isUpadteContentResponsesLoading,
    isUpadteContentSettingsLoading,
    isUpadteContentSettingsSuccess,
    isUpadteContentSuccess,
    isUpadteContentLoading
  ]);

  // Helper function to match IDs with type conversion
  const matchId = (id1, id2) => {
    return id1 === id2 || id1 === Number(id2) || String(id1) === String(id2);
  };

  const mapUnitToOption = unit => {
    if (!unit) {
      return null;
    }

    const unitId = unit.unitId ?? unit.id ?? null;

    return {
      label: unit.unitName || unit.name || '',
      id: unitId
    };
  };

  const resolveUnitId = unit => unit?.id ?? unit?.unitId ?? null;

  const getEffectiveContentId = () =>
    contentId ||
    contentDetails?.contentId ||
    Number(localStorage.getItem('localContentId')) ||
    0;

  const isUnitRequiredForContentType = contentTypeId =>
    contentTypeId && contentTypeId !== 'Core';

  const isThemeRequiredForContentType = contentTypeId =>
    contentTypeId && contentTypeId !== 'State';

  // Filter grades based on Content Type
  const getFilteredGradeList = () => {
    if (!formik.values?.contentType?.id) {
      return noAuthGradeList || [];
    }

    if (formik.values.contentType.id === 'State') {
      // For State: Show only grades 1-10
      return (noAuthGradeList || []).filter(
        grade => grade.gradeId >= 1 && grade.gradeId <= 10
      );
    }

    // For All and other types: Show all grades
    return noAuthGradeList || [];
  };

  const getValidationSchema = () => {
    // Only apply validation schema for tab 0 (File Upload)
    if (initialValues?.tabValue === 0) {
      // For edit mode, make theme and medium optional if content doesn't have these values
      const isEditMode =
        location.pathname === '/content-management/edit-content';
      const hasThemeData = contentDetails?.theme;
      const hasMediumData = contentDetails?.medium;

      return Yup.object().shape({
        contentTitle: Yup.string().required('Title is required'),
        grade: Yup.object().nullable().required('Please select grade'), // Always required now
        tags: Yup.array().nullable(),
        section: Yup.object().nullable().required('Please select section'),
        contentType: Yup.object()
          .nullable()
          .required('Please select Content type'),
        contentVisibility: Yup.object()
          .nullable()
          .required('Please select Content visibility'),
        // Theme validation will be handled in validate function
        theme:
          isEditMode && !hasThemeData
            ? Yup.object().nullable()
            : Yup.object().nullable(),
        // Medium validation
        medium:
          isEditMode && !hasMediumData
            ? Yup.object().nullable()
            : Yup.object().nullable().required('Please select medium')
      });
    }
    // For tabs 1 and 2, return empty schema (no validation)
    return Yup.object().shape({});
  };

  // Custom validation function for dynamic requirements
  const validateForm = values => {
    const errors = {};

    if (initialValues?.tabValue === 0) {
      const contentType = values?.contentType?.id;

      // Grade is always required now
      if (!values.grade) {
        errors.grade = 'Please select grade';
      }

      // Theme is required for Core and other types, not for State
      if (isThemeRequiredForContentType(contentType) && !values.theme) {
        errors.theme = 'Please select theme';
      }

      if (
        isUnitRequiredForContentType(contentType) &&
        !resolveUnitId(values.unit)
      ) {
        errors.unit = 'Please select unit';
      }
    }

    return errors;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      contentTitle: '',
      contentDescription: '',
      grade: null,
      tags: [],
      section: null,
      contentType: null,
      contentVisibility: null,
      theme: null,
      medium: null,
      unit: null,

      likes: false,
      comments: false,
      share: false,
      download: false,

      allowPoints: false,
      pointsPerLike: 0,
      pointsPerComment: 0,
      pointsPerDownload: 0,
      pointsPerShare: 0,
      notifyAllRelevantUserByGrade: false,
      notifyAllStudents: false,
      notifyAllTeachers: false,
      notifyAllUserInSystem: false,
      flashCard: []
    },
    validationSchema: getValidationSchema(),
    validate: validateForm,
    onSubmit: values => {
      if (initialValues?.tabValue === 0) {
        const addPayload = {
          uploadType: fileType || '',
          title: values?.contentTitle,
          description: values?.contentDescription,
          duration: fileDuration,
          sectionId: values?.section?.id,
          contentType: mapContentTypeToApi(values?.contentType?.label),
          contentVisibility: values?.contentVisibility?.label,
          grade: values?.grade?.id,
          tagNames: isArrayNotEmpty(values?.tags)
            ? values.tags.map(tag => tag.label)
            : [],
          themeId: values?.theme?.id || null,
          mediumId: values?.medium?.id || null,
          unitId: resolveUnitId(values?.unit),
          status: 'Saved',
          loggedInUserName: authData?.userName
        };

        const effectiveContentId = getEffectiveContentId();

        const editPayload = {
          contentId: effectiveContentId,
          uploadType: fileType || '',
          title: values?.contentTitle,
          description: values?.contentDescription,
          duration: fileDuration,
          sectionId: values?.section?.id,
          contentType: mapContentTypeToApi(values?.contentType?.label),
          contentVisibility: values?.contentVisibility?.label,
          grade: values?.grade?.id,
          tagNames: isArrayNotEmpty(values?.tags)
            ? values.tags.map(tag => tag.label)
            : [],
          themeId: values?.theme?.id || null,
          mediumId: values?.medium?.id || null,
          unitId: resolveUnitId(values?.unit),
          status: 'Saved',
          loggedInUserName: authData?.userName,
          updateThumbnailFlag:
            isBrowserFile(thumbnailFile) ||
            (fileType === 'Image' && isBrowserFile(file))
        };

        const formData = new FormData();
        formData.append('file', file);

        if (fileType === 'PDF' && isBrowserFile(secondFile)) {
          formData.append('file2', secondFile);
        }

        // For Image type, use the main file as thumbnail
        // For Video/Audio/PDF type, use the selected thumbnail file
        console.log(
          'FileType:',
          fileType,
          'File:',
          file,
          'ThumbnailFile:',
          thumbnailFile
        );

        if (fileType === 'Image' && isBrowserFile(file)) {
          console.log('Using main file as thumbnail for Image');
          formData.append('thumbnail', file);
        } else if (isBrowserFile(thumbnailFile)) {
          formData.append('thumbnail', thumbnailFile);
        } else {
          formData.append('thumbnail', null);
        }

        if (
          location.pathname === '/content-management/edit-content' ||
          effectiveContentId
        ) {
          formData.append('content', JSON.stringify(editPayload));
          dispatch(updateContent({ formData, contentId: effectiveContentId }));
        } else {
          formData.append('content', JSON.stringify(addPayload));
          dispatch(addNewContent(formData));
        }
      } else if (initialValues?.tabValue === 1) {
        const activeContentId = getEffectiveContentId();
        const payload = {
          likes: formik?.values?.likes,
          likesContentType: 'All',
          comments: formik?.values?.comments,
          commentsContentType: 'All',
          share: formik?.values?.share,
          shareContentType: 'All',
          download: formik?.values?.download,
          downloadContentType: 'All',
          loggedInUserName: authData?.userName
        };
        dispatch(
          updateContentResponses({ payload, contentId: activeContentId })
        );
      } else if (initialValues?.tabValue === 2) {
        const activeContentId = getEffectiveContentId();
        const payload = {
          allowPoints: formik?.values?.allowPoints,
          likesPoints: formik?.values?.pointsPerLike,
          sharePoints: formik?.values?.pointsPerShare,
          commentPoints: formik?.values?.pointsPerComment,
          downloadPoints: formik?.values?.pointsPerDownload,
          notifyAllRelevantUserByGrade:
            formik?.values?.notifyAllRelevantUserByGrade,
          notifyAllUserInSystem: formik?.values?.notifyAllUserInSystem,
          notifyAllTeachers: formik?.values?.notifyAllTeachers,
          notifyAllStudents: formik?.values?.notifyAllStudents,
          loggedInUserName: authData?.userName
        };
        dispatch(
          updateContentSettings({ payload, contentId: activeContentId })
        );
      }
    }
  });

  useEffect(() => {
    if (
      isPublishContentSuccess ||
      isDeleteQuestionSuccess ||
      isSaveFlashCardSuccess
    ) {
      let encryptId = location.state?.encryptedContentId || encryptedId;
      dispatch(getContentById({ encryptId, userId }));
    }
  }, [
    isPublishContentSuccess,
    isDeleteQuestionSuccess,
    isSaveFlashCardSuccess
  ]);

  // Call getContentById after updateContentResponses success to refresh data
  useEffect(() => {
    if (isUpadteContentResponsesSuccess && !isUpadteContentResponsesLoading) {
      let encryptId = location.state?.encryptedContentId || encryptedId;
      dispatch(getContentById({ encryptId, userId }));

      // Move to next tab after data refresh
      if (initialValues.tabValue === 1) {
        setInitalValues({
          ...initialValues,
          tabValue: 2
        });
      }
    }
  }, [isUpadteContentResponsesSuccess, isUpadteContentResponsesLoading]);

  // Call getContentById after updateContentSettings success to refresh data
  useEffect(() => {
    if (isUpadteContentSettingsSuccess && !isUpadteContentSettingsLoading) {
      console.log('updateContentSettings successful, refreshing content data');
      let encryptId = location.state?.encryptedContentId || encryptedId;
      dispatch(getContentById({ encryptId, userId }));
    }
  }, [isUpadteContentSettingsSuccess, isUpadteContentSettingsLoading]);

  // Update validation schema when tab changes
  useEffect(() => {
    // Force formik to re-validate with new schema
    formik.setErrors({});
    formik.setTouched({});
  }, [initialValues?.tabValue]);

  // Inital UseEffect
  useEffect(() => {
    document.title = createTitle('Add new content');
    dispatch(getNoAuthGradeList());
    dispatch(getSectionList());
    dispatch(getTagList());
    dispatch(getThemeList());
    dispatch(getMediumList());
  }, []);

  // Add success notification states
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (!isAddNewTagLoading && isAddNewTagSuccess) {
      dispatch(getTagList());
      setShowSuccessNotification(true);
      setSuccessMessage('Tag added successfully!');
      setTimeout(() => setShowSuccessNotification(false), 3000);
    }
    if (!isAddNewSectionLoading && isAddNewSectionSuccess) {
      dispatch(getSectionList());
      setShowSuccessNotification(true);
      setSuccessMessage('Section added successfully!');
      setTimeout(() => setShowSuccessNotification(false), 3000);
    }
    if (!isAddNewMediumLoading && isAddNewMediumSuccess) {
      dispatch(getMediumList());
      setShowSuccessNotification(true);
      setSuccessMessage('Medium added successfully!');
      setTimeout(() => setShowSuccessNotification(false), 3000);
    }
  }, [
    isAddNewTagLoading,
    isAddNewTagSuccess,
    isAddNewSectionSuccess,
    isAddNewSectionLoading,
    isAddNewMediumLoading,
    isAddNewMediumSuccess
  ]);

  const convertPdfToImage = (fileUrl, sourceFileName = 'document.pdf') => {
    const requestId = ++pdfThumbRequestIdRef.current;
    const loadingTask = pdfjsLib.getDocument(fileUrl);

    loadingTask.promise.then(
      pdf => {
        pdf.getPage(1).then(page => {
          const scale = 1.5;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          page
            .render({
              canvasContext: context,
              viewport: viewport
            })
            .promise.then(() => {
              if (
                requestId !== pdfThumbRequestIdRef.current ||
                thumbnailSourceRef.current === 'user' ||
                thumbnailSourceRef.current === 'existing'
              ) {
                return;
              }

              const imageUrl = canvas.toDataURL('image/png');
              setPreviewUrl(imageUrl);

              canvas.toBlob(blob => {
                if (
                  !blob ||
                  requestId !== pdfThumbRequestIdRef.current ||
                  thumbnailSourceRef.current === 'user' ||
                  thumbnailSourceRef.current === 'existing'
                ) {
                  return;
                }

                const thumbName = `${sourceFileName.replace(/\.pdf$/i, '')}-thumbnail.png`;
                const thumbFile = new File([blob], thumbName, {
                  type: 'image/png'
                });
                thumbnailSourceRef.current = 'auto';
                setThumbnailFile(thumbFile);
                setThumbnailFileName(thumbName);
                setThumbnailProgress(100);
              }, 'image/png');
            });
        });
      },
      error => {
        console.error('Error loading PDF:', error);
        if (thumbnailSourceRef.current !== 'user') {
          setPreviewUrl(IMG_PDF_PREVIEW);
        }
      }
    );
  };

  const handlePublishButtonClick = () => {
    const payload = {
      contentId: getEffectiveContentId(),
      loggedInUserName: authData?.userName,
      status: normalizeContentPublishStatus(
        contentStatus || contentDetails?.status
      ),
      contentType:
        contentDetails?.contentType || formik.values?.contentType?.label
    };
    dispatch(publishContent({ payload }));
  };
  // UseEffect for getDetails
  useEffect(() => {
    // CRITICAL: Early return if contentDetails is null to prevent all null reference errors
    if (!contentDetails) {
      console.log('Skipping data population - contentDetails is null');
      return;
    }

    // Add comprehensive safety checks to prevent null reference errors
    if (!formik || !formik.setValues || !formik.values) {
      console.log('Skipping data population - missing required objects:', {
        contentDetails: !!contentDetails,
        formik: !!formik,
        setValues: !!formik?.setValues,
        values: !!formik?.values
      });
      return;
    }

    if (
      location.pathname === '/content-management/edit-content' &&
      contentDetails &&
      sectionList &&
      noAuthGradeList &&
      tagList &&
      themeList &&
      Array.isArray(themeList) &&
      themeList.length > 0 &&
      mediumList &&
      Array.isArray(mediumList) &&
      mediumList.length > 0 &&
      unitList &&
      Array.isArray(unitList)
    ) {
      console.log('=== EDIT MODE DEBUG - Theme/Medium/Unit ===');
      console.log('contentDetails from API:', contentDetails);
      console.log('---');
      console.log('Checking all possible field names:');
      console.log('contentDetails.theme:', contentDetails?.theme);
      console.log('contentDetails.themeName:', contentDetails?.themeName);
      console.log('contentDetails.themeId:', contentDetails?.themeId);
      console.log('contentDetails.medium:', contentDetails?.medium);
      console.log('contentDetails.mediumName:', contentDetails?.mediumName);
      console.log('contentDetails.mediumId:', contentDetails?.mediumId);
      console.log('contentDetails.unit:', contentDetails?.unit);
      console.log('contentDetails.unitName:', contentDetails?.unitName);
      console.log('contentDetails.unitId:', contentDetails?.unitId);
      console.log('contentDetails.section:', contentDetails?.section);
      console.log('---');
      console.log('themeList from Redux:', themeList);
      console.log('mediumList from Redux:', mediumList);
      console.log('unitList from Redux:', unitList);
      console.log('sectionList from Redux:', sectionList);

      let tempGrade = noAuthGradeList?.filter(
        grade => grade && matchId(grade.gradeId, contentDetails?.grade)
      );

      let tempTags = tagList?.filter(
        tag =>
          tag &&
          contentDetails?.contentTags?.some(
            contentTag => contentTag && contentTag.tagName === tag.tagName
          )
      );

      let tempSection = sectionList?.filter(
        section => section && section.sectionName === contentDetails?.section
      );

      // Use the correct field structure - theme/medium/unit are objects with name properties
      let tempTheme = themeList?.filter(theme => {
        if (!theme) return false;
        return theme.themeName === contentDetails?.themeName;
      });

      let tempMedium = mediumList?.filter(medium => {
        if (!medium) return false;
        return medium.mediumName === contentDetails?.mediumName;
      });

      let tempUnit = unitList?.filter(unit => {
        if (!unit) return false;
        const unitId = unit.unitId ?? unit.id;
        return (
          matchId(unitId, contentDetails?.unitId) ||
          unit.unitName === contentDetails?.unitName ||
          unit.unitName === contentDetails?.unit?.unitName
        );
      });

      console.log('---');
      console.log('tempSection after filter:', tempSection);
      console.log('tempTheme after filter:', tempTheme);
      console.log('tempMedium after filter:', tempMedium);
      console.log('tempUnit after filter:', tempUnit);
      console.log('=== END DEBUG ===');

      formik.setValues({
        contentTitle: contentDetails?.title || '',
        contentDescription: contentDetails?.description || '',
        grade:
          tempGrade && tempGrade.length > 0
            ? { id: tempGrade[0]?.gradeId, label: tempGrade[0]?.gradeName }
            : null,
        tags: isArrayNotEmpty(tempTags)
          ? tempTags?.map(cc => {
              return { id: cc.tagId, label: cc.tagName };
            })
          : [],
        section:
          tempSection && tempSection.length > 0
            ? {
                id: tempSection[0]?.contentSectionId,
                label: tempSection[0]?.sectionName
              }
            : null,
        theme:
          tempTheme && tempTheme.length > 0
            ? { id: tempTheme[0]?.themeId, label: tempTheme[0]?.themeName }
            : null,
        medium:
          tempMedium && tempMedium.length > 0
            ? { id: tempMedium[0]?.mediumId, label: tempMedium[0]?.mediumName }
            : null,
        unit: tempUnit[0] ? mapUnitToOption(tempUnit[0]) : null,
        contentType: mapContentTypeToFormOption(contentDetails?.contentType),
        contentVisibility: contentDetails?.contentVisibility
          ? {
              label: contentDetails?.contentVisibility,
              id: contentDetails?.contentVisibility
            }
          : null,
        likes: contentDetails?.likes || false,
        comments: contentDetails?.comments || false,
        share: contentDetails?.share || false,
        download: contentDetails?.download || false,
        allowPoints: contentDetails?.allowPoints || false,
        pointsPerLike: contentDetails?.likesPoints || 0,
        pointsPerComment: contentDetails?.commentPoints || 0,
        pointsPerDownload: contentDetails?.downloadPoints || 0,
        pointsPerShare: contentDetails?.sharePoints || 0,
        notifyAllRelevantUserByGrade:
          contentDetails?.notifyAllRelevantUserByGrade || false,
        notifyAllStudents: contentDetails?.notifyAllStudents || false,
        notifyAllTeachers: contentDetails?.notifyAllTeachers || false,
        notifyAllUserInSystem: contentDetails?.notifyAllUserInSystem || false,
        flashCard: contentDetails?.flashCard || []
      });
      setFileDuration(contentDetails?.duration);
      setFileType(contentDetails?.uploadType);

      contentDetails?.uploadType === 'PDF'
        ? contentDetails?.thumbnailFileUrl
          ? setPreviewUrl(contentDetails.thumbnailFileUrl)
          : convertPdfToImage(
              contentDetails?.contentFileUrl,
              contentDetails?.contentFileName || 'document.pdf'
            )
        : setPreviewUrl(contentDetails?.thumbnailFileUrl);

      setFile(contentDetails?.contentFileUrl);
      setFileName(contentDetails?.contentFileName);
      setThumbnailFile(contentDetails?.thumbnailFileUrl);
      setThumbnailFileName(contentDetails?.thumbnailFileName);
      thumbnailSourceRef.current = contentDetails?.thumbnailFileUrl
        ? 'existing'
        : 'none';

      if (contentDetails?.uploadType === 'PDF') {
        const secondPdf = getSecondPdfFromContent(contentDetails);
        setSecondFile(secondPdf.url);
        setSecondFileName(secondPdf.name);
        setSecondFileProgress(secondPdf.url ? 100 : 0);
      } else {
        setSecondFile(null);
        setSecondFileName('');
        setSecondFileProgress(0);
      }

      setProgress(100);
      setThumbnailProgress(100);
      setContentStatus(contentDetails?.status);
      if (contentDetails?.contentId) {
        setContentId(contentDetails.contentId);
        localStorage.setItem('localContentId', contentDetails.contentId);
      }

      // Load units for the selected grade in edit mode
      if (contentDetails?.grade) {
        dispatch(getUnitsByGrade(contentDetails.grade));
      }
    } else if (
      location.pathname === '/content-management/add-new-content' &&
      (contentDetails?.contentId || localStorage?.getItem('localContentId')) &&
      contentDetails &&
      formik &&
      formik.setValues &&
      themeList &&
      Array.isArray(themeList) &&
      themeList.length > 0 &&
      mediumList &&
      Array.isArray(mediumList) &&
      mediumList.length > 0
    ) {
      console.log('=== ADD NEW CONTENT MODE DEBUG - Theme/Medium/Unit ===');
      console.log('contentDetails from API:', contentDetails);
      console.log('---');
      console.log('Checking all possible field names:');
      console.log('contentDetails.theme:', contentDetails?.theme);
      console.log('contentDetails.themeName:', contentDetails?.themeName);
      console.log('contentDetails.themeId:', contentDetails?.themeId);
      console.log('contentDetails.medium:', contentDetails?.medium);
      console.log('contentDetails.mediumName:', contentDetails?.mediumName);
      console.log('contentDetails.mediumId:', contentDetails?.mediumId);
      console.log('contentDetails.unit:', contentDetails?.unit);
      console.log('contentDetails.unitName:', contentDetails?.unitName);
      console.log('contentDetails.unitId:', contentDetails?.unitId);
      console.log('contentDetails.section:', contentDetails?.section);
      console.log('---');
      console.log('themeList from Redux:', themeList);
      console.log('mediumList from Redux:', mediumList);
      console.log('unitList from Redux:', unitList);
      console.log('sectionList from Redux:', sectionList);

      let tempGrade = noAuthGradeList?.filter(
        grade => grade && matchId(grade.gradeId, contentDetails?.grade)
      );

      let tempTags = tagList?.filter(
        tag =>
          tag &&
          contentDetails?.contentTags?.some(
            contentTag => contentTag && contentTag.tagName === tag.tagName
          )
      );

      let tempSection = sectionList?.filter(
        section => section && section.sectionName === contentDetails?.section
      );

      // Use the correct field structure - theme/medium/unit are objects with name properties
      let tempTheme = themeList?.filter(theme => {
        if (!theme) return false;
        return theme.themeName === contentDetails?.themeName;
      });

      let tempMedium = mediumList?.filter(medium => {
        if (!medium) return false;
        return medium.mediumName === contentDetails?.mediumName;
      });

      let tempUnit = unitList?.filter(unit => {
        if (!unit) return false;
        const unitId = unit.unitId ?? unit.id;
        return (
          matchId(unitId, contentDetails?.unitId) ||
          unit.unitName === contentDetails?.unitName ||
          unit.unitName === contentDetails?.unit?.unitName
        );
      });

      console.log('---');
      console.log('tempSection after filter:', tempSection);
      console.log('tempTheme after filter:', tempTheme);
      console.log('tempMedium after filter:', tempMedium);
      console.log('tempUnit after filter:', tempUnit);
      console.log('=== END DEBUG ===');

      formik.setValues({
        contentTitle: contentDetails?.title || '',
        contentDescription: contentDetails?.description || '',
        grade:
          tempGrade && tempGrade.length > 0
            ? { id: tempGrade[0]?.gradeId, label: tempGrade[0]?.gradeName }
            : null,
        tags: isArrayNotEmpty(tempTags)
          ? tempTags?.map(cc => {
              return { id: cc.tagId, label: cc.tagName };
            })
          : [],
        section:
          tempSection && tempSection.length > 0
            ? {
                id: tempSection[0]?.contentSectionId,
                label: tempSection[0]?.sectionName
              }
            : null,
        theme:
          tempTheme && tempTheme.length > 0
            ? { id: tempTheme[0]?.themeId, label: tempTheme[0]?.themeName }
            : null,
        medium:
          tempMedium && tempMedium.length > 0
            ? { id: tempMedium[0]?.mediumId, label: tempMedium[0]?.mediumName }
            : null,
        unit: tempUnit[0] ? mapUnitToOption(tempUnit[0]) : null,
        contentType: mapContentTypeToFormOption(contentDetails?.contentType),
        contentVisibility: contentDetails?.contentVisibility
          ? {
              label: contentDetails?.contentVisibility,
              id: contentDetails?.contentVisibility
            }
          : null,
        likes: contentDetails?.likes || false,
        comments: contentDetails?.comments || false,
        share: contentDetails?.share || false,
        download: contentDetails?.download || false,
        allowPoints: contentDetails?.allowPoints || false,
        pointsPerLike: contentDetails?.likesPoints || 0,
        pointsPerComment: contentDetails?.commentPoints || 0,
        pointsPerDownload: contentDetails?.downloadPoints || 0,
        pointsPerShare: contentDetails?.sharePoints || 0,
        notifyAllRelevantUserByGrade:
          contentDetails?.notifyAllRelevantUserByGrade || false,
        notifyAllStudents: contentDetails?.notifyAllStudents || false,
        notifyAllTeachers: contentDetails?.notifyAllTeachers || false,
        notifyAllUserInSystem: contentDetails?.notifyAllUserInSystem || false,
        flashCard: contentDetails?.flashCard || []
      });
      setFileDuration(contentDetails?.duration);
      setFileType(contentDetails?.uploadType);

      contentDetails?.uploadType === 'PDF'
        ? contentDetails?.thumbnailFileUrl
          ? setPreviewUrl(contentDetails.thumbnailFileUrl)
          : convertPdfToImage(
              contentDetails?.contentFileUrl,
              contentDetails?.contentFileName || 'document.pdf'
            )
        : setPreviewUrl(contentDetails?.thumbnailFileUrl);

      setFile(contentDetails?.contentFileUrl);
      setFileName(contentDetails?.contentFileName);
      setThumbnailFile(contentDetails?.thumbnailFileUrl);
      setThumbnailFileName(contentDetails?.thumbnailFileName);
      thumbnailSourceRef.current = contentDetails?.thumbnailFileUrl
        ? 'existing'
        : 'none';

      if (contentDetails?.uploadType === 'PDF') {
        const secondPdf = getSecondPdfFromContent(contentDetails);
        setSecondFile(secondPdf.url);
        setSecondFileName(secondPdf.name);
        setSecondFileProgress(secondPdf.url ? 100 : 0);
      } else {
        setSecondFile(null);
        setSecondFileName('');
        setSecondFileProgress(0);
      }
      setPreviewUrl(contentDetails?.thumbnailFileUrl);
      setProgress(100);
      setThumbnailProgress(100);
      setContentStatus(contentDetails?.status);
      if (contentDetails?.contentId) {
        setContentId(contentDetails.contentId);
        localStorage.setItem('localContentId', contentDetails.contentId);
      }

      // Load units for the selected grade in add-new-content mode
      if (contentDetails?.grade) {
        dispatch(getUnitsByGrade(contentDetails.grade));
      }

      // setEncryptedId(contentDetails?.encrypted_content_id || '')
    }
    setGamificationData(contentDetails);
  }, [contentDetails, noAuthGradeList, tagList, sectionList]);

  // Separate useEffect to populate theme/medium/unit ONLY ONCE when data is available (EDIT MODE ONLY)
  useEffect(() => {
    if (
      contentDetails &&
      themeList &&
      Array.isArray(themeList) &&
      themeList.length > 0 &&
      mediumList &&
      Array.isArray(mediumList) &&
      mediumList.length > 0 &&
      unitList &&
      Array.isArray(unitList) &&
      !isThemeMediumUnitPopulated && // Only run once
      formik &&
      formik.setFieldValue &&
      location.pathname === '/content-management/edit-content' // ONLY for edit mode
    ) {
      console.log('=== POPULATING THEME/MEDIUM/UNIT FROM EDIT DATA ===');
      console.log('contentDetails.themeName:', contentDetails?.themeName);
      console.log('contentDetails.mediumName:', contentDetails?.mediumName);
      console.log('contentDetails.unitName:', contentDetails?.unitName);

      // Find and save theme value
      if (contentDetails?.theme?.themeName && !savedThemeValue) {
        let tempTheme = themeList?.filter(theme => {
          if (!theme) return false;
          return theme.themeName === contentDetails?.theme?.themeName;
        });

        if (tempTheme && tempTheme.length > 0) {
          const themeValue = {
            id: tempTheme[0]?.themeId,
            label: tempTheme[0]?.themeName
          };
          setSavedThemeValue(themeValue);
          formik.setFieldValue('theme', themeValue);
          console.log('Theme value saved and set:', themeValue);
        }
      }

      // Find and save medium value
      if (contentDetails?.medium?.mediumName && !savedMediumValue) {
        let tempMedium = mediumList?.filter(medium => {
          if (!medium) return false;
          return medium.mediumName === contentDetails?.medium?.mediumName;
        });

        if (tempMedium && tempMedium.length > 0) {
          const mediumValue = {
            id: tempMedium[0]?.mediumId,
            label: tempMedium[0]?.mediumName
          };
          setSavedMediumValue(mediumValue);
          formik.setFieldValue('medium', mediumValue);
          console.log('Medium value saved and set:', mediumValue);
        }
      }

      // Find and save unit value
      if (contentDetails?.unit?.unitName && !savedUnitValue) {
        let tempUnit = unitList?.filter(unit => {
          if (!unit) return false;
          return unit.unitName === contentDetails?.unit?.unitName;
        });

        if (tempUnit && tempUnit.length > 0) {
          const unitValue = mapUnitToOption(tempUnit[0]);
          setSavedUnitValue(unitValue);
          formik.setFieldValue('unit', unitValue);
          console.log('Unit value saved and set:', unitValue);
        }
      }

      // Mark as populated to prevent re-running
      setIsThemeMediumUnitPopulated(true);
      console.log('=== THEME/MEDIUM/UNIT POPULATION COMPLETE ===');
    }
  }, [
    contentDetails,
    themeList,
    mediumList,
    unitList,
    isThemeMediumUnitPopulated
  ]);

  // Use saved values in formik when available
  useEffect(() => {
    if (savedThemeValue && formik && !formik.values.theme) {
      formik.setFieldValue('theme', savedThemeValue);
      console.log('Restored theme from local state:', savedThemeValue);
    }
    if (savedMediumValue && formik && !formik.values.medium) {
      formik.setFieldValue('medium', savedMediumValue);
      console.log('Restored medium from local state:', savedMediumValue);
    }
    if (savedUnitValue && formik && !formik.values.unit) {
      formik.setFieldValue('unit', savedUnitValue);
      console.log('Restored unit from local state:', savedUnitValue);
    }
  }, [savedThemeValue, savedMediumValue, savedUnitValue]);

  const simulateUploadProgress = () => {
    let uploadProgress = 0;
    const interval = setInterval(() => {
      uploadProgress += 10;
      setProgress(uploadProgress);
      if (uploadProgress >= 100) clearInterval(interval);
    }, 300); // Simulate upload in steps
  };

  useEffect(() => {
    if (!isPublishContentLoading && isPublishContentSuccess) {
      setContentId('');
      localStorage.removeItem('localContentId');
      setTimeout(() => {
        navigate('/content-management');
      }, 2000);
    }
  }, [isPublishContentSuccess]);

  const handleFileUpload = event => {
    const uploadedFile = event.target.files?.[0];
    if (!uploadedFile) {
      return;
    }

    const fileNameLower = uploadedFile.name.toLowerCase();
    const isAllowedFileType =
      CONTENT_FILE_EXTENSIONS.some(ext => fileNameLower.endsWith(ext)) ||
      isPdfFile(uploadedFile) ||
      uploadedFile.type.startsWith('image/');

    if (!isAllowedFileType) {
      setShowError(true);
      setShowErrorMessage('Uploaded file type is not supported.');
      event.target.value = '';
      return;
    }

    if (uploadedFile.size > MAX_CONTENT_FILE_SIZE_BYTES) {
      setShowError(true);
      setShowErrorMessage(
        'File size exceeds the 1 GB limit. Please upload a smaller file.'
      );
      event.target.value = '';
      return;
    }

    const resolvedFileType =
      getUploadTypeFromFileName(uploadedFile.name) ||
      (isPdfFile(uploadedFile) ? 'PDF' : '');

    setFile(uploadedFile);
    setFileName(uploadedFile.name);
    setFileType(resolvedFileType);
    setThumbnailFile(null);
    setThumbnailFileName('');
    setThumbnailProgress(0);
    thumbnailSourceRef.current = 'none';

    if (resolvedFileType !== 'PDF') {
      setSecondFile(null);
      setSecondFileName('');
      setSecondFileProgress(0);
    }

    const objectUrl = URL.createObjectURL(uploadedFile);
    if (resolvedFileType === 'PDF') {
      convertPdfToImage(objectUrl, uploadedFile.name);
    } else {
      setPreviewUrl(objectUrl);
    }
    simulateUploadProgress();

    if (
      uploadedFile.type.startsWith('video/') ||
      uploadedFile.type.startsWith('audio/')
    ) {
      const mediaElement = document.createElement(
        uploadedFile.type.startsWith('video/') ? 'video' : 'audio'
      );
      mediaElement.src = objectUrl;

      mediaElement.addEventListener('loadedmetadata', () => {
        const duration = mediaElement.duration;
        const minutes = Math.floor(duration / 60);
        const seconds = Math.floor(duration % 60);
        setFileDuration(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
      });
    }

    event.target.value = '';
  };

  const handleRemoveFile = () => {
    setFile(null);
    setProgress(0);
    setFileType('');
    setThumbnailFile(null);
    setPreviewUrl('');
    setThumbnailProgress(0);
    thumbnailSourceRef.current = 'none';
    setSecondFile(null);
    setSecondFileName('');
    setSecondFileProgress(0);
  };

  const simulateSecondPdfUploadProgress = () => {
    let uploadProgress = 0;
    setSecondFileProgress(0);
    const interval = setInterval(() => {
      uploadProgress += 10;
      setSecondFileProgress(uploadProgress);
      if (uploadProgress >= 100) clearInterval(interval);
    }, 300);
  };

  const handleRemoveSecondFile = () => {
    setSecondFile(null);
    setSecondFileName('');
    setSecondFileProgress(0);
  };

  const handleSecondPdfUpload = event => {
    const uploadedFile = event.target.files?.[0];
    if (!uploadedFile) {
      return;
    }

    if (!isPdfFile(uploadedFile)) {
      setShowError(true);
      setShowErrorMessage('Please upload a PDF file.');
      event.target.value = '';
      return;
    }

    if (uploadedFile.size > MAX_CONTENT_FILE_SIZE_BYTES) {
      setShowError(true);
      setShowErrorMessage(
        'File size exceeds the 1 GB limit. Please upload a smaller file.'
      );
      event.target.value = '';
      return;
    }

    setSecondFile(uploadedFile);
    setSecondFileName(uploadedFile.name);
    simulateSecondPdfUploadProgress();
    event.target.value = '';
  };

  const areAllRequiredFieldsFilled = () => {
    const effectiveContentId = getEffectiveContentId();
    const isEditMode =
      location.pathname === '/content-management/edit-content' ||
      !!effectiveContentId;

    // Tab 0 (File Upload): Require all form fields + file upload
    if (initialValues?.tabValue === 0) {
      const contentType = formik.values.contentType?.id;

      // Base required fields
      const baseRequiredFields =
        formik.values.contentTitle &&
        formik.values.grade &&
        formik.values.section &&
        formik.values.contentType?.id &&
        formik.values.contentVisibility?.id &&
        formik.values.medium &&
        (file || (isEditMode && contentDetails?.contentFileUrl));

      // Theme is required for Core, disabled for State
      const themeRequired = isThemeRequiredForContentType(contentType)
        ? formik.values.theme
        : true;
      const unitRequired = isUnitRequiredForContentType(contentType)
        ? resolveUnitId(formik.values.unit)
        : true;

      const requiredFieldsFilled =
        baseRequiredFields && themeRequired && unitRequired;

      const isThumbnailRequired =
        fileType !== 'Image'
          ? thumbnailFile || (isEditMode && contentDetails?.thumbnailFileUrl)
          : true;
      return requiredFieldsFilled && isThumbnailRequired;
    }

    // Tab 1 (Responses and Interactions): Only require contentId to exist
    if (initialValues?.tabValue === 1) {
      return !!effectiveContentId;
    }

    // Tab 2 (Settings): Require contentId + points validation if allowPoints is enabled
    if (initialValues?.tabValue === 2) {
      const arePointsFieldsFilled = formik?.values?.allowPoints
        ? (!gamificationData?.likes || !!formik.values.pointsPerLike) &&
          (!gamificationData?.share || !!formik.values.pointsPerShare) &&
          (!gamificationData?.comments || !!formik.values.pointsPerComment) &&
          (!gamificationData?.download || !!formik.values.pointsPerDownload)
        : true;

      return !!effectiveContentId && arePointsFieldsFilled;
    }

    return false;
  };

  const isSaveDisabled = !areAllRequiredFieldsFilled();

  const responseInteractionMenu = [
    { id: 1, menuName: 'Likes', field: 'likes' },
    { id: 2, menuName: 'Comments', field: 'comments' },
    { id: 3, menuName: 'Share', field: 'share' },
    { id: 4, menuName: 'Download', field: 'download' }
  ];

  const handleResponsesSwitchChange = id => {
    const field = RESPONSE_INTERACTION_FIELDS[id];
    if (field) {
      formik.setFieldValue(field, !formik.values[field]);
    }
  };

  const handleCloseNewTagModal = () => {
    setIsNewTagModalOpen(false);
  };

  const handleCloseNewMediumModal = () => {
    setIsNewMediumModalOpen(false);
  };

  const handleCloseNewSectionModal = () => {
    setIsNewSectionModalOpen(false);
  };

  const handleCloseNewQuestionModal = () => {
    setIsNewQuestionModalOpen(false);
    setEditQuestionData(null);
  };

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
        setShowErrorMessage('');
      }, [2000]);
    }
  }, [showError]);

  const simulateThumbnailUploadProgress = () => {
    let uploadProgress = 0;
    const interval = setInterval(() => {
      uploadProgress += 10;
      setThumbnailProgress(uploadProgress);
      if (uploadProgress >= 100) clearInterval(interval);
    }, 300);
  };

  const handleThumbnailRemoveFile = () => {
    thumbnailSourceRef.current = 'none';
    setThumbnailFile(null);
    setPreviewUrl('');
    setThumbnailProgress(0);
  };

  const handleThumbnailFileUpload = event => {
    const uploadedFile = event.target.files[0];

    const allowedImageExtensions = ['.png', '.jpg', '.jpeg', '.gif'];

    const isAllowedThumbnailFile =
      (allowedImageExtensions.some(ext =>
        uploadedFile.name.toLowerCase().endsWith(ext)
      ) ||
        uploadedFile.type.startsWith('image/')) &&
      uploadedFile.size <= 5 * 1024 * 1024;

    if (isAllowedThumbnailFile) {
      if (uploadedFile) {
        thumbnailSourceRef.current = 'user';
        pdfThumbRequestIdRef.current += 1;
        setThumbnailFile(uploadedFile);
        setThumbnailFileName(uploadedFile.name);
        // setIsVideo(uploadedFile.type.startsWith('video/'));
        setPreviewUrl(URL.createObjectURL(uploadedFile));
        simulateThumbnailUploadProgress();
      }
    } else {
      setShowError(true);
    }
    event.target.value = '';
  };

  // Custom Pagination

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Add Questions

  const handleAddQuestion = newQuestion => {
    let tempQuestionList = [...questionList];

    tempQuestionList.push(newQuestion);
    setQuestionList(tempQuestionList);
  };

  const handleUpdateQuestions = newQuestion => {
    setQuestionList(prevList =>
      prevList.map(question =>
        question.questionId === newQuestion.questionId ? newQuestion : question
      )
    );
  };

  const handleDeleteModal = id => {
    setIsDeleteModalOpen(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteId(null);
  };

  const handleDeleteQuestion = () => {
    let payload = {
      id: deleteId || 0,
      userName: authData?.userName || ''
    };
    dispatch(deleteQuestions(payload));
    setDeleteId(null);
  };

  useEffect(() => {
    if (!isDeleteQuestionLoading && isDeleteQuestionSuccess) {
      setIsDeleteModalOpen(false);
    }
  }, [isDeleteQuestionLoading, isDeleteQuestionSuccess]);

  const handleEditQuestion = id => {
    const question = questionList.find(question => question.questionId === id);

    if (question) {
      setEditQuestionData(question);
      setIsNewQuestionModalOpen(true);
    }
  };

  const itemsPerPage = 10;
  const startIndex = page * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  useEffect(() => {
    if (Array.isArray(contentDetails?.flashCard)) {
      const questions = contentDetails.flashCard.filter(
        item => item?.questionText || item?.questionId
      );
      setQuestionList(questions);
    }
  }, [contentDetails?.flashCard]);

  const mappingList = questionList.slice(startIndex, endIndex);

  return (
    <>
      <Grid
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography fontSize={32} fontWeight="700" display={'flex'}>
          {location.pathname === '/content-management/edit-content'
            ? 'Edit Content'
            : 'Add New Content'}
          <Typography
            ml={1}
            fontSize={20}
            fontWeight="700"
            alignSelf={'center'}
          ></Typography>
        </Typography>
        <Grid display={'flex'} gap={2} alignItems={'center'}>
          {initialValues?.tabValue === 2 && (
            <>
              <Button
                variant="outlined"
                disabled={isSaveDisabled}
                onClick={() => {
                  setIsPreviewOpen(true);
                }}
                sx={{
                  borderColor: colorPrimary,
                  borderRadius: '10px',
                  color: colorTextBlack,
                  borderWidth: '2px',
                  height: '42px',
                  width: '106px',
                  '&:hover': {
                    borderColor: colorPrimary,
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    borderWidth: '2px'
                  }
                }}
              >
                Preview
              </Button>
              <LoadingButton
                onClick={handlePublishButtonClick}
                disabled={isSaveDisabled}
                type="submit"
                variant="contained"
                style={{
                  height: '42px',
                  width: '110px'
                }}
              >
                {contentStatus === 'Saved' ? 'Publish' : 'Unpublish'}
              </LoadingButton>
            </>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        display={'flex'}
        flexDirection={'column'}
        elevation={0}
        borderRadius={'8px'}
      >
        <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
          <Grid
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Tabs
              value={initialValues.tabValue}
              onChange={(val, newValue) =>
                setInitalValues({
                  ...initialValues,
                  tabValue: newValue,
                  page: 0
                })
              }
              TabIndicatorProps={{
                sx: {
                  height: '4px'
                  //   borderRadius: '4px'
                }
              }}
            >
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 0 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 0
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="13.5"
                      height="13.5"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.75 10.25V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V10.25M11.75 5L8 1.25M8 1.25L4.25 5M8 1.25V10.25"
                        stroke={
                          initialValues.tabValue === 0
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Overview"
                    count={0}
                    selected={initialValues.tabValue === 0}
                    isCountRequired={false}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 1 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 1
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="12"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 9H4M10 12.375H4M10 5.625H4M13 5.1V12.9C13 14.1601 13 14.7902 12.7548 15.2715C12.539 15.6948 12.1948 16.039 11.7715 16.2548C11.2902 16.5 10.6601 16.5 9.4 16.5H4.6C3.33988 16.5 2.70982 16.5 2.22852 16.2548C1.80516 16.039 1.46095 15.6948 1.24524 15.2715C1 14.7902 1 14.1601 1 12.9V5.1C1 3.83988 1 3.20982 1.24524 2.72852C1.46095 2.30516 1.80516 1.96095 2.22852 1.74524C2.70982 1.5 3.33988 1.5 4.6 1.5H9.4C10.6601 1.5 11.2902 1.5 11.7715 1.74524C12.1948 1.96095 12.539 2.30516 12.7548 2.72852C13 3.20982 13 3.83988 13 5.1Z"
                        stroke={
                          initialValues.tabValue === 1
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                disabled={!getEffectiveContentId()}
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Responses and Interactions"
                    count={0}
                    selected={initialValues.tabValue === 1}
                    isCountRequired={false}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 2 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 2
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="13.5"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.04628 14.5283L6.48462 15.5142C6.61492 15.8076 6.82757 16.057 7.09678 16.232C7.366 16.4069 7.6802 16.5001 8.00128 16.5C8.32237 16.5001 8.63657 16.4069 8.90578 16.232C9.17499 16.057 9.38764 15.8076 9.51795 15.5142L9.95628 14.5283C10.1123 14.1785 10.3748 13.8869 10.7063 13.695C11.0399 13.5026 11.4258 13.4206 11.8088 13.4608L12.8813 13.575C13.2005 13.6088 13.5227 13.5492 13.8088 13.4035C14.0949 13.2578 14.3325 13.0322 14.4929 12.7542C14.6536 12.4763 14.7301 12.1577 14.7132 11.8372C14.6964 11.5166 14.5869 11.2079 14.3979 10.9483L13.7629 10.0758C13.5368 9.76285 13.416 9.38611 13.4179 9C13.4179 8.61494 13.5398 8.23976 13.7663 7.92833L14.4013 7.05583C14.5902 6.79632 14.6997 6.48755 14.7166 6.16701C14.7334 5.84646 14.6569 5.52791 14.4963 5.25C14.3359 4.97193 14.0982 4.74637 13.8121 4.60067C13.5261 4.45497 13.2039 4.3954 12.8846 4.42917L11.8121 4.54333C11.4291 4.58356 11.0432 4.50159 10.7096 4.30917C10.3775 4.11619 10.1149 3.82302 9.95962 3.47167L9.51795 2.48583C9.38764 2.19238 9.17499 1.94304 8.90578 1.76805C8.63657 1.59306 8.32237 1.49995 8.00128 1.5C7.6802 1.49995 7.366 1.59306 7.09678 1.76805C6.82757 1.94304 6.61492 2.19238 6.48462 2.48583L6.04628 3.47167C5.89098 3.82302 5.62844 4.11619 5.29628 4.30917C4.96269 4.50159 4.57678 4.58356 4.19378 4.54333L3.11795 4.42917C2.7987 4.3954 2.4765 4.45497 2.19043 4.60067C1.90437 4.74637 1.66671 4.97193 1.50628 5.25C1.34565 5.52791 1.26912 5.84646 1.28598 6.16701C1.30285 6.48755 1.41237 6.79632 1.60128 7.05583L2.23628 7.92833C2.46274 8.23976 2.58468 8.61494 2.58461 9C2.58468 9.38506 2.46274 9.76024 2.23628 10.0717L1.60128 10.9442C1.41237 11.2037 1.30285 11.5124 1.28598 11.833C1.26912 12.1535 1.34565 12.4721 1.50628 12.75C1.66687 13.0279 1.90455 13.2534 2.19058 13.399C2.47661 13.5447 2.79872 13.6044 3.11795 13.5708L4.19045 13.4567C4.57345 13.4164 4.95936 13.4984 5.29295 13.6908C5.62634 13.8833 5.89011 14.1765 6.04628 14.5283Z"
                        stroke={
                          initialValues.tabValue === 2
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.99994 11.25C9.24258 11.25 10.2499 10.2426 10.2499 9C10.2499 7.75736 9.24258 6.75 7.99994 6.75C6.7573 6.75 5.74994 7.75736 5.74994 9C5.74994 10.2426 6.7573 11.25 7.99994 11.25Z"
                        stroke={
                          initialValues.tabValue === 2
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                disabled={!getEffectiveContentId()}
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Settings"
                    count={0}
                    selected={initialValues.tabValue === 2}
                    isCountRequired={false}
                  />
                }
              />
            </Tabs>
          </Grid>
        </Grid>
      </Grid>

      {initialValues?.tabValue === 0 && (
        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ paddingX: '14px', pt: 1 }}
        >
          <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              width={'912px'}
            >
              <Box>
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Title
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <TextField
                      maxRows={4}
                      name="contentTitle"
                      placeholder="Enter interesting title for the user "
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 200 }}
                      value={formik.values?.contentTitle}
                      onChange={formik.handleChange}
                      error={
                        formik.touched?.contentTitle &&
                        Boolean(formik.errors?.contentTitle)
                      }
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}
                    >
                      <FormHelperText id="contentTitle">
                        {formik.touched?.contentTitle &&
                          formik.errors?.contentTitle}
                      </FormHelperText>
                      <Typography variant="body2" color="textSecondary">
                        {formik.values?.contentTitle
                          ? formik.values?.contentTitle?.length
                          : 0}
                        /200
                      </Typography>
                    </div>
                  </FormControl>
                </Box>

                {/* Description */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    // required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Description
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <TextField
                      name="contentDescription"
                      placeholder="Add description"
                      variant="outlined"
                      size="small"
                      maxRows={3}
                      sx={{
                        '& textarea': {
                          '&::-webkit-scrollbar': {
                            width: '0.2em'
                          },
                          '&::-webkit-scrollbar-track': {
                            background: '#f5f5f5',
                            width: '3px',
                            borderRadius: '10px'
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#4E565F',
                            borderRadius: '10px',
                            border: '2px solid #4E565F'
                          }
                        }
                      }}
                      inputProps={{
                        maxLength: 300
                      }}
                      multiline
                      value={formik.values?.contentDescription}
                      error={
                        formik.touched?.contentDescription &&
                        Boolean(formik.errors?.contentDescription)
                      }
                      onChange={formik.handleChange}
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <FormHelperText id="contentDescription">
                        {formik.touched?.contentDescription &&
                          formik.errors?.contentDescription}
                      </FormHelperText>
                      <Typography variant="body2" color="textSecondary">
                        {formik.values?.contentDescription
                          ? formik.values?.contentDescription?.length
                          : 0}
                        /300
                      </Typography>
                    </div>
                  </FormControl>
                </Box>

                {/* Content Type */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Content type
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik.values?.contentType}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('contentType', newValue);
                        // Reset dependent fields when Content Type changes
                        formik.setFieldValue('grade', null);
                        formik.setFieldValue('theme', null);
                        formik.setFieldValue('unit', null);

                        // If Core is selected, also clear unit since it won't be visible
                        if (newValue?.id === 'Core') {
                          formik.setFieldValue('unit', null);
                        }
                      }}
                      getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={ALLOWED_CONTENT_TYPE_OPTIONS}
                      renderInput={params => (
                        <TextField
                          name="contentType"
                          {...params}
                          placeholder="Select content type"
                          error={
                            formik.touched?.contentType &&
                            Boolean(formik.errors?.contentType)
                          }
                          helperText={
                            formik.touched?.contentType &&
                            formik.errors?.contentType
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Grade - Show for all Content Types */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Grade
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.grade}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('grade', newValue);
                        if (newValue?.id) {
                          dispatch(getUnitsByGrade(newValue.id));
                        } else {
                          formik.setFieldValue('unit', null);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(getFilteredGradeList())
                          ? getFilteredGradeList().map(c => {
                              return {
                                label: c.gradeName,
                                id: c.gradeId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="grade"
                          {...params}
                          placeholder="Select grade"
                          error={
                            formik.touched?.grade &&
                            Boolean(formik.errors?.grade)
                          }
                          helperText={
                            formik.touched?.grade && formik.errors?.grade
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Theme - Show only when Content Type is selected */}
                {formik.values?.contentType?.id && (
                  <Box width={'416px'} mb={2}>
                    <InputLabel
                      required={isThemeRequiredForContentType(
                        formik.values?.contentType?.id
                      )}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Theme
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        disabled={formik.values?.contentType?.id === 'State'}
                        value={formik?.values?.theme}
                        onChange={(event, newValue) => {
                          console.log('=== THEME DROPDOWN CHANGE ===');
                          console.log('Selected theme:', newValue);
                          console.log(
                            'themeList available:',
                            themeList?.length
                          );
                          formik.setFieldValue('theme', newValue);
                          console.log(
                            'Theme set in formik:',
                            formik.values.theme
                          );
                        }}
                        isOptionEqualToValue={(option, value) =>
                          value ? matchId(option.id, value.id) : false
                        }
                        getOptionLabel={getOptionLabel}
                        options={
                          isArrayNotEmpty(themeList)
                            ? themeList.map(t => {
                                return {
                                  label: t.themeName,
                                  id: t.themeId
                                };
                              })
                            : []
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            name="theme"
                            {...params}
                            placeholder="Select theme"
                            error={
                              formik.touched?.theme &&
                              Boolean(formik.errors?.theme)
                            }
                            helperText={
                              formik.touched?.theme && formik.errors?.theme
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Box>
                )}

                {/* Medium */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Medium
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.medium}
                      onChange={(event, newValue) => {
                        console.log('=== MEDIUM DROPDOWN CHANGE ===');
                        console.log('Selected medium:', newValue);
                        console.log(
                          'mediumList available:',
                          mediumList?.length
                        );
                        formik.setFieldValue('medium', newValue);
                        console.log(
                          'Medium set in formik:',
                          formik.values.medium
                        );
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(mediumList)
                          ? mediumList.map(m => {
                              return {
                                label: m.mediumName,
                                id: m.mediumId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="medium"
                          {...params}
                          placeholder="Select medium"
                          error={
                            formik.touched?.medium &&
                            Boolean(formik.errors?.medium)
                          }
                          helperText={
                            formik.touched?.medium && formik.errors?.medium
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Unit - Hide when Core is selected */}
                {formik.values?.contentType?.id !== 'Core' && (
                  <Box width={'416px'} mb={2}>
                    <InputLabel
                      required
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Unit
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik?.values?.unit}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('unit', newValue);
                        }}
                        disabled={!formik?.values?.grade}
                        isOptionEqualToValue={(option, value) =>
                          value ? matchId(option.id, value.id) : false
                        }
                        getOptionLabel={getOptionLabel}
                        options={
                          isArrayNotEmpty(unitList)
                            ? unitList
                                .map(mapUnitToOption)
                                .filter(option => option?.id != null)
                            : []
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            name="unit"
                            {...params}
                            placeholder="Select unit"
                            error={
                              formik.touched?.unit &&
                              Boolean(formik.errors?.unit)
                            }
                            helperText={
                              formik.touched?.unit && formik.errors?.unit
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Box>
                )}

                {/* Tags */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Tags
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.tags || []}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('tags', newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(tagList)
                          ? tagList
                              .map(c => ({
                                label: c.tagName,
                                id: c.contentTagId
                              }))
                              .filter(
                                option =>
                                  !formik.values?.tags?.some(
                                    tag => tag.id === option.id
                                  )
                              )
                          : []
                      }
                      disableClearable
                      multiple
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            size="small"
                            color="secondary"
                            key={index}
                            label={option.label || option.tagName}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                      renderInput={params => (
                        <TextField
                          name="tags"
                          {...params}
                          placeholder="Select tag"
                          sx={{
                            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingLeft: '12px'
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                {/* <svg
                                  width="17"
                                  height="16"
                                  viewBox="0 0 17 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.83334 5.3335H5.84001M1.83334 3.46683L1.83334 6.44984C1.83334 6.77596 1.83334 6.93902 1.87018 7.09247C1.90285 7.22852 1.95672 7.35858 2.02982 7.47787C2.11228 7.61243 2.22758 7.72773 2.45818 7.95833L7.5706 13.0708C8.36264 13.8628 8.75865 14.2588 9.21531 14.4072C9.617 14.5377 10.0497 14.5377 10.4514 14.4072C10.908 14.2588 11.3041 13.8628 12.0961 13.0708L13.5706 11.5962C14.3626 10.8042 14.7587 10.4082 14.907 9.95153C15.0375 9.54984 15.0375 9.11715 14.907 8.71546C14.7587 8.2588 14.3626 7.86279 13.5706 7.07075L8.45818 1.95833C8.22758 1.72773 8.11228 1.61243 7.97772 1.52998C7.85843 1.45687 7.72837 1.403 7.59232 1.37034C7.43887 1.3335 7.27581 1.3335 6.94969 1.3335L3.96668 1.3335C3.21994 1.3335 2.84657 1.3335 2.56136 1.47882C2.31047 1.60665 2.1065 1.81063 1.97867 2.06151C1.83334 2.34672 1.83334 2.72009 1.83334 3.46683ZM6.16668 5.3335C6.16668 5.51759 6.01744 5.66683 5.83334 5.66683C5.64925 5.66683 5.50001 5.51759 5.50001 5.3335C5.50001 5.1494 5.64925 5.00016 5.83334 5.00016C6.01744 5.00016 6.16668 5.1494 6.16668 5.3335Z"
                                    stroke={colorTextGrey}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg> */}
                              </>
                            )
                          }}
                          error={
                            formik.touched?.tags && Boolean(formik.errors?.tags)
                          }
                          helperText={
                            formik.touched?.tags && formik.errors?.tags
                          }
                        />
                      )}
                    />
                    <Box display={'flex'} flexWrap={'wrap'}>
                      {isArrayNotEmpty(formik.values?.tags) &&
                        formik.values?.tags.map((cc, indiIdx) => {
                          return (
                            <Typography
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: 1,
                                mr: 1,
                                fontWeight: '600',
                                padding: '2px 6px',
                                background: colorSecondary,
                                borderRadius: '6px',
                                border: `1px solid ${colorPrimary}`
                              }}
                              key={indiIdx}
                              variant="caption"
                            >
                              {cc?.label || cc?.tagName}
                              <IconButton
                                onClick={() => {
                                  const newTags = [...formik.values.tags];
                                  newTags.splice(indiIdx, 1);
                                  formik.setFieldValue('tags', newTags);
                                }}
                                sx={{
                                  padding: 0,
                                  ml: 2
                                }}
                              >
                                <Close fontSize="small" color="action" />
                              </IconButton>
                            </Typography>
                          );
                        })}
                    </Box>
                  </FormControl>
                  <div
                    style={{
                      display: 'flex',

                      justifyContent: 'flex-end'
                    }}
                  >
                    <Tooltip placement="top" title="Click to add new tag">
                      <Button
                        sx={{
                          height: 30,
                          color: isHover ? colorPrimary : colorTextBlack,
                          borderBottom: `1px solid ${isHover ? colorPrimary : colorTextBlack}`,
                          borderRadius: 0
                        }}
                        onClick={() => {
                          setIsNewTagModalOpen(true);
                        }}
                        size="small"
                      >
                        <SvgIcon
                          fontSize="small"
                          sx={{
                            marginRight: 0.6,
                            height: '16px',
                            width: '16px'
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                              stroke={isHover ? colorPrimary : colorTextBlack}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        Add new tag
                      </Button>
                    </Tooltip>
                  </div>
                </Box>

                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Section
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.section}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('section', newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(sectionList)
                          ? sectionList.map(c => {
                              return {
                                label: c.sectionName,
                                id: c.contentSectionId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="section"
                          {...params}
                          placeholder="Select section"
                          error={
                            formik.touched?.section &&
                            Boolean(formik.errors?.section)
                          }
                          helperText={
                            formik.touched?.section && formik.errors?.section
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                  <div
                    style={{
                      display: 'flex',

                      justifyContent: 'flex-end'
                    }}
                  >
                    <Tooltip placement="top" title="Click to add new section">
                      <Button
                        sx={{
                          height: 30,
                          color: isHover ? colorPrimary : colorTextBlack,
                          borderBottom: `1px solid ${isHover ? colorPrimary : colorTextBlack}`,
                          borderRadius: 0
                        }}
                        onClick={() => {
                          setIsNewSectionModalOpen(true);
                        }}
                        size="small"
                      >
                        <SvgIcon
                          fontSize="small"
                          sx={{
                            marginRight: 0.6,
                            height: '16px',
                            width: '16px'
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                              stroke={isHover ? colorPrimary : colorTextBlack}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        Add new section
                      </Button>
                    </Tooltip>
                  </div>
                </Box>

                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Content Visibility
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik.values?.contentVisibility}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('contentVisibility', newValue);
                      }}
                      disableClearable
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={[
                        { label: 'Private', id: 'Private' },
                        { label: 'Published', id: 'Published' }
                      ]}
                      renderInput={params => (
                        <TextField
                          name="contentVisibility"
                          {...params}
                          placeholder="Select content visibility"
                          error={
                            formik.touched?.contentVisibility &&
                            Boolean(formik.errors?.contentVisibility)
                          }
                          helperText={
                            formik.touched?.contentVisibility &&
                            formik.errors?.contentVisibility
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box>
                <InputLabel
                  required
                  sx={{
                    fontWeight: '700',
                    color: colorTextBlack,
                    fontSize: '16px',
                    mb: 0.6
                  }}
                >
                  {fileType === 'PDF' ? 'Upload PDF 1' : 'Upload file'}
                </InputLabel>
                {!file && (
                  <Box
                    width={'416px'}
                    mb={2}
                    border={'1px dashed #ccc'}
                    display="flex"
                    borderRadius={'8px'}
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height={'150px'}
                    onDrop={e => {
                      e.preventDefault();
                      handleFileUpload({
                        target: { files: e.dataTransfer.files }
                      });
                    }}
                    onDragOver={e => e.preventDefault()}
                  >
                    {/* Upload Icon with Custom Color */}
                    <Box
                      sx={{
                        height: '24px',
                        width: '24px',
                        color: '#CBD2D9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2
                      }}
                    >
                      <UploadIcon sx={{ color: '#CBD2D9' }} />
                    </Box>

                    {/* Combined Text Line */}
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      fontSize={'16px'}
                      color={colorLinkGrey}
                      marginBottom={1}
                    >
                      Drag and drop or{' '}
                      <Typography
                        component="label"
                        variant="body2"
                        fontWeight={600}
                        fontSize={'16px'}
                        color="#CBD2D9"
                        sx={{
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        browse
                        <input
                          type="file"
                          hidden
                          accept={CONTENT_FILE_ACCEPT}
                          onChange={handleFileUpload}
                        />
                      </Typography>{' '}
                      your file
                    </Typography>

                    <Typography
                      color={colorLinkGrey}
                      fontSize={'12px'}
                      fontWeight={500}
                      paddingX={4}
                    >
                      Supported file types: jpg, jpeg, png, gif, mp4, mov, avi,
                      mkv, mp3,
                    </Typography>
                    <Typography
                      color={colorLinkGrey}
                      fontSize={'12px'}
                      fontWeight={500}
                      paddingX={4}
                    >
                      wav, ogg, pdf, doc, docx, xls, xlsx, ppt, pptx (Maximum
                      size : 1GB)
                    </Typography>
                  </Box>
                )}

                {file && (
                  <Box mt={2} width={'416px'}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={1}
                      border="1px solid #E4E7EB"
                      borderRadius="8px"
                      paddingX="12px"
                      paddingY="4px"
                    >
                      <Box display="flex" alignItems="center">
                        {fileType === 'Image' ? (
                          <SvgIcon
                            fontSize="small"
                            sx={{ fontSize: 18, marginRight: 1 }}
                          >
                            <svg
                              width="12"
                              height="16"
                              viewBox="0 0 12 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.8 13H3.62091C3.21704 13 3.0151 13 2.92159 12.9201C2.84045 12.8508 2.79739 12.7469 2.80577 12.6405C2.81541 12.5179 2.95821 12.3751 3.24379 12.0895L8.91242 6.42091C9.17643 6.15691 9.30844 6.0249 9.46066 5.97544C9.59455 5.93193 9.73878 5.93193 9.87268 5.97544C10.0249 6.0249 10.1569 6.1569 10.4209 6.42091L13 9V9.8M9.8 13C10.9201 13 11.4802 13 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C13 11.4802 13 10.9201 13 9.8M9.8 13H4.2C3.0799 13 2.51984 13 2.09202 12.782C1.71569 12.5903 1.40973 12.2843 1.21799 11.908C1 11.4802 1 10.9201 1 9.8V4.2C1 3.0799 1 2.51984 1.21799 2.09202C1.40973 1.71569 1.71569 1.40973 2.09202 1.21799C2.51984 1 3.0799 1 4.2 1H9.8C10.9201 1 11.4802 1 11.908 1.21799C12.2843 1.40973 12.5903 1.71569 12.782 2.09202C13 2.51984 13 3.0799 13 4.2V9.8M6 4.66667C6 5.40305 5.40305 6 4.66667 6C3.93029 6 3.33333 5.40305 3.33333 4.66667C3.33333 3.93029 3.93029 3.33333 4.66667 3.33333C5.40305 3.33333 6 3.93029 6 4.66667Z"
                                stroke="#1F2933"
                                strokeWidth="1.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        ) : (
                          ''
                        )}
                        <Typography
                          variant="body1"
                          color={colorTextBlack}
                          fontSize={'12px'}
                          fontWeight={600}
                        >
                          {fileName}
                        </Typography>
                      </Box>
                      <IconButton onClick={handleRemoveFile} size="small">
                        {/* <CloseOutlined fontSize="small" /> */}
                        <SvgIcon fontSize="small" sx={{ fontSize: 14 }}>
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.33329 1.66699L1.66663 8.33366M1.66663 1.66699L8.33329 8.33366"
                              stroke="#1F2933"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                      </IconButton>
                    </Box>
                    {progress !== 100 && (
                      <>
                        <Typography
                          variant="body2"
                          color={colorLinkGrey}
                          fontSize={'12px'}
                          fontWeight={500}
                        >
                          {progress === 100
                            ? `${progress} % completed`
                            : `Upload Progress: ${progress} %`}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={progress}
                          sx={{
                            mt: 1,
                            '& .MuiLinearProgress-bar': {
                              backgroundColor:
                                progress === 100 ? '#749E35' : undefined
                            }
                          }}
                        />
                      </>
                    )}
                  </Box>
                )}

                {fileType === 'PDF' && file && (
                  <Box mt={3} width={'416px'}>
                    <InputLabel
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Upload PDF 2
                    </InputLabel>
                    <Typography
                      color={colorLinkGrey}
                      fontSize={'12px'}
                      fontWeight={500}
                      mb={1}
                    >
                      Optional. You can add a second PDF.
                    </Typography>
                    {!secondFile && (
                      <Box
                        width={'416px'}
                        mb={2}
                        border={'1px dashed #ccc'}
                        display="flex"
                        borderRadius={'8px'}
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height={'150px'}
                        onDrop={e => {
                          e.preventDefault();
                          handleSecondPdfUpload({
                            target: { files: e.dataTransfer.files }
                          });
                        }}
                        onDragOver={e => e.preventDefault()}
                      >
                        <Box
                          sx={{
                            height: '24px',
                            width: '24px',
                            color: '#CBD2D9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2
                          }}
                        >
                          <UploadIcon sx={{ color: '#CBD2D9' }} />
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          fontSize={'16px'}
                          color={colorLinkGrey}
                          marginBottom={1}
                        >
                          Drag and drop or{' '}
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                            fontSize={'16px'}
                            color="#CBD2D9"
                            sx={{
                              textDecoration: 'underline',
                              cursor: 'pointer'
                            }}
                          >
                            browse
                            <input
                              type="file"
                              hidden
                              accept={PDF_FILE_ACCEPT}
                              onChange={handleSecondPdfUpload}
                            />
                          </Typography>{' '}
                          your file
                        </Typography>
                        <Typography
                          color={colorLinkGrey}
                          fontSize={'12px'}
                          fontWeight={500}
                          paddingX={4}
                        >
                          Supported file type: pdf (Maximum size : 1GB)
                        </Typography>
                      </Box>
                    )}
                    {secondFile && (
                      <Box mt={2} width={'416px'}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                          border="1px solid #E4E7EB"
                          borderRadius="8px"
                          paddingX="12px"
                          paddingY="4px"
                        >
                          <Box display="flex" alignItems="center">
                            <Typography
                              variant="body1"
                              color={colorTextBlack}
                              fontSize={'12px'}
                              fontWeight={600}
                            >
                              {secondFileName}
                            </Typography>
                          </Box>
                          <IconButton
                            onClick={handleRemoveSecondFile}
                            size="small"
                          >
                            <SvgIcon fontSize="small" sx={{ fontSize: 14 }}>
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33329 1.66699L1.66663 8.33366M1.66663 1.66699L8.33329 8.33366"
                                  stroke="#1F2933"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </IconButton>
                        </Box>
                        {secondFileProgress !== 100 && (
                          <>
                            <Typography
                              variant="body2"
                              color={colorLinkGrey}
                              fontSize={'12px'}
                              fontWeight={500}
                            >
                              {secondFileProgress === 100
                                ? `${secondFileProgress} % completed`
                                : `Upload Progress: ${secondFileProgress} %`}
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={secondFileProgress}
                              sx={{
                                mt: 1,
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor:
                                    secondFileProgress === 100
                                      ? '#749E35'
                                      : undefined
                                }
                              }}
                            />
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                )}

                {fileType !== 'Image' && file && (
                  <Box mt={3} width={'416px'}>
                    <InputLabel
                      required
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Add Thumbnail
                    </InputLabel>
                    {!thumbnailFile && (
                      <Box
                        width={'416px'}
                        mb={2}
                        border={'1px dashed #ccc'}
                        display="flex"
                        borderRadius={'8px'}
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height={'150px'}
                        onDrop={e => {
                          e.preventDefault();
                          handleThumbnailFileUpload({
                            target: { files: e.dataTransfer.files }
                          });
                        }}
                        onDragOver={e => e.preventDefault()}
                      >
                        {/* Upload Icon with Custom Color */}
                        <Box
                          sx={{
                            height: '18px',
                            width: '18px',
                            color: '#CBD2D9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2
                          }}
                        >
                          <SvgIcon
                            fontSize="small"
                            sx={{ fontSize: 18, marginRight: 1 }}
                          >
                            <svg
                              width="19"
                              height="19"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14 4.5L17 1.5M17 1.5L20 4.5M17 1.5V7.5M10.5 2.5H5.8C4.11984 2.5 3.27976 2.5 2.63803 2.82698C2.07354 3.1146 1.6146 3.57354 1.32698 4.13803C1 4.77976 1 5.61984 1 7.3V15.7C1 17.3802 1 18.2202 1.32698 18.862C1.6146 19.4265 2.07354 19.8854 2.63803 20.173C3.27976 20.5 4.11984 20.5 5.8 20.5H15C15.93 20.5 16.395 20.5 16.7765 20.3978C17.8117 20.1204 18.6204 19.3117 18.8978 18.2765C19 17.895 19 17.43 19 16.5M8.5 8C8.5 9.10457 7.60457 10 6.5 10C5.39543 10 4.5 9.10457 4.5 8C4.5 6.89543 5.39543 6 6.5 6C7.60457 6 8.5 6.89543 8.5 8ZM12.99 11.4181L4.53115 19.108C4.05536 19.5406 3.81747 19.7568 3.79643 19.9442C3.77819 20.1066 3.84045 20.2676 3.96319 20.3755C4.10478 20.5 4.42628 20.5 5.06929 20.5H14.456C15.8951 20.5 16.6147 20.5 17.1799 20.2582C17.8894 19.9547 18.4547 19.3894 18.7582 18.6799C19 18.1147 19 17.3951 19 15.956C19 15.4717 19 15.2296 18.9471 15.0042C18.8805 14.7208 18.753 14.4554 18.5733 14.2264C18.4303 14.0442 18.2412 13.8929 17.8631 13.5905L15.0658 11.3527C14.6874 11.0499 14.4982 10.8985 14.2898 10.8451C14.1061 10.798 13.9129 10.8041 13.7325 10.8627C13.5279 10.9291 13.3486 11.0921 12.99 11.4181Z"
                                stroke="#1F2933"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        </Box>

                        {/* Combined Text Line */}
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          fontSize={'14px'}
                          color={colorLinkGrey}
                        >
                          Drag and drop or{' '}
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                            fontSize={'14px'}
                            color="#CBD2D9"
                            sx={{
                              textDecoration: 'underline',
                              cursor: 'pointer'
                            }}
                          >
                            browse
                            <input
                              type="file"
                              hidden
                              onChange={handleThumbnailFileUpload}
                            />
                          </Typography>{' '}
                          your file
                        </Typography>

                        <Typography
                          color={colorLinkGrey}
                          fontSize={'12px'}
                          fontWeight={500}
                        >
                          Supported file types: jpg, jpeg, png (Maximum size :
                          5MB)
                        </Typography>
                      </Box>
                    )}

                    {thumbnailFile && (
                      <Box mt={2} width={'416px'}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                          border="1px solid #E4E7EB"
                          borderRadius="8px"
                          paddingX="12px"
                          paddingY="4px"
                        >
                          <Box display="flex" alignItems="center">
                            <SvgIcon
                              fontSize="small"
                              sx={{ fontSize: 18, marginRight: 1 }}
                            >
                              <svg
                                width="12"
                                height="16"
                                viewBox="0 0 12 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.8 13H3.62091C3.21704 13 3.0151 13 2.92159 12.9201C2.84045 12.8508 2.79739 12.7469 2.80577 12.6405C2.81541 12.5179 2.95821 12.3751 3.24379 12.0895L8.91242 6.42091C9.17643 6.15691 9.30844 6.0249 9.46066 5.97544C9.59455 5.93193 9.73878 5.93193 9.87268 5.97544C10.0249 6.0249 10.1569 6.1569 10.4209 6.42091L13 9V9.8M9.8 13C10.9201 13 11.4802 13 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C13 11.4802 13 10.9201 13 9.8M9.8 13H4.2C3.0799 13 2.51984 13 2.09202 12.782C1.71569 12.5903 1.40973 12.2843 1.21799 11.908C1 11.4802 1 10.9201 1 9.8V4.2C1 3.0799 1 2.51984 1.21799 2.09202C1.40973 1.71569 1.71569 1.40973 2.09202 1.21799C2.51984 1 3.0799 1 4.2 1H9.8C10.9201 1 11.4802 1 11.908 1.21799C12.2843 1.40973 12.5903 1.71569 12.782 2.09202C13 2.51984 13 3.0799 13 4.2V9.8M6 4.66667C6 5.40305 5.40305 6 4.66667 6C3.93029 6 3.33333 5.40305 3.33333 4.66667C3.33333 3.93029 3.93029 3.33333 4.66667 3.33333C5.40305 3.33333 6 3.93029 6 4.66667Z"
                                  stroke="#1F2933"
                                  strokeWidth="1.3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>

                            <Typography
                              variant="body1"
                              color={colorTextBlack}
                              fontSize={'12px'}
                              fontWeight={600}
                            >
                              {thumbnailFileName}
                            </Typography>
                          </Box>
                          <IconButton
                            onClick={handleThumbnailRemoveFile}
                            size="small"
                          >
                            <SvgIcon fontSize="small" sx={{ fontSize: 14 }}>
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33329 1.66699L1.66663 8.33366M1.66663 1.66699L8.33329 8.33366"
                                  stroke="#1F2933"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </IconButton>
                        </Box>
                        {thumbnailProgress !== 100 && (
                          <>
                            <Typography
                              variant="body2"
                              color={colorLinkGrey}
                              fontSize={'12px'}
                              fontWeight={500}
                            >
                              {thumbnailProgress === 100
                                ? `${thumbnailProgress} % completed`
                                : `Upload Progress: ${thumbnailProgress} %`}
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={thumbnailProgress}
                              sx={{
                                mt: 1,
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor:
                                    thumbnailProgress === 100
                                      ? '#749E35'
                                      : undefined
                                }
                              }}
                            />
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                )}

                {/* Video preview */}
                {fileType === 'Video' &&
                  file &&
                  thumbnailFile &&
                  progress === 100 &&
                  thumbnailProgress === 100 && (
                    <Box mt={2} width={'416px'}>
                      <Card
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          maxWidth: '416px',
                          border: '1px solid #e0e0e0',
                          boxShadow: 'none',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          mt: 2,
                          padding: '12px'
                        }}
                      >
                        <Box
                          sx={{
                            position: 'relative',
                            width: '100%',
                            height: '244px',
                            backgroundColor: '#f0f0f0'
                          }}
                        >
                          <img
                            src={previewUrl}
                            alt="Uploaded thumbnail"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '8px'
                            }}
                          />
                        </Box>

                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            lineHeight: '20px',
                            marginTop: '12px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word'
                          }}
                        >
                          {formik?.values?.contentTitle}
                        </Typography>
                      </Card>
                    </Box>
                  )}

                {fileType === 'Image' && file && progress === 100 && (
                  <Box mt={2} width={'416px'}>
                    <Card
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        maxWidth: '416px',
                        border: '1px solid #e0e0e0',
                        boxShadow: 'none',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        mt: 2,
                        padding: '12px',
                        backgroundColor: '#fff'
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          width: '100%'
                          // height: '284px'
                        }}
                      >
                        <Box backgroundColor="#fff">
                          <img
                            src={
                              location.pathname ===
                              '/content-management/edit-content'
                                ? file
                                : previewUrl
                            }
                            alt="Image thumbnail"
                            style={{
                              width: '100%',
                              height: '100%',
                              maxHeight: '244px',
                              minHeight: '244px',
                              objectFit: 'cover',
                              borderRadius: '8px'
                            }}
                          />
                        </Box>

                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            lineHeight: '20px',
                            marginTop: '12px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word'
                          }}
                        >
                          {formik?.values?.contentTitle}
                        </Typography>
                      </Box>
                    </Card>
                  </Box>
                )}

                {/* Preview for others */}
                {(fileType === 'PDF' ||
                  fileType === 'EXCEL' ||
                  fileType === 'MSWORD' ||
                  fileType === 'POWERPOINT' ||
                  fileType === 'Audio') &&
                  file &&
                  thumbnailFile &&
                  thumbnailProgress === 100 &&
                  progress === 100 && (
                    <>
                      <Box mt={2} width={'416px'}>
                        <Card
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            maxWidth: '416px',
                            border: '1px solid #e0e0e0',
                            boxShadow: 'none',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            mt: 2,
                            padding: '12px',
                            backgroundColor: '#fff'
                          }}
                        >
                          <Box
                            sx={{
                              position: 'relative',
                              width: '100%'
                            }}
                          >
                            {fileType === 'PDF' ||
                            fileType === 'EXCEL' ||
                            fileType === 'MSWORD' ||
                            fileType === 'POWERPOINT' ||
                            fileType === 'Audio' ? (
                              <Box backgroundColor="#fff">
                                <img
                                  src={previewUrl}
                                  alt="Image thumbnail"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    maxHeight: '244px',
                                    minHeight: '244px',
                                    objectFit: 'cover',
                                    borderRadius: '8px'
                                  }}
                                />
                              </Box>
                            ) : (
                              // : fileType === 'Audio' ? (
                              //   <>
                              //     <Box marginBottom={1}>
                              //       <SvgIcon
                              //         fontSize="small"
                              //         sx={{ fontSize: 24, marginRight: 1 }}
                              //       >
                              //         <svg
                              //           width="24"
                              //           height="24"
                              //           viewBox="0 0 24 24"
                              //           fill="none"
                              //           xmlns="http://www.w3.org/2000/svg"
                              //         >
                              //           <g clipPath="url(#clip0_2221_16481)">
                              //             <path
                              //               d="M15.4962 5.29688V0H3.1875C2.79913 0 2.48438 0.314758 2.48438 0.703125V23.2969C2.48438 23.6852 2.79913 24 3.1875 24H20.7931C21.1815 24 21.4962 23.6852 21.4962 23.2969V6H16.1993C15.811 6 15.4962 5.68524 15.4962 5.29688ZM9.7804 10.4462C9.7804 9.2276 10.7717 8.23627 11.9903 8.23627C13.2089 8.23627 14.2002 9.2276 14.2002 10.4462V13.7725C14.2002 14.991 13.2089 15.9825 11.9903 15.9825C10.7717 15.9825 9.7804 14.991 9.7804 13.7725V10.4462ZM16.1138 15.1549C15.8948 16.021 15.3647 16.8047 14.6212 17.3611C14.061 17.7805 13.394 18.058 12.6934 18.1701V18.9512H13.6404C14.0288 18.9512 14.3436 19.266 14.3436 19.6544C14.3436 20.0427 14.0288 20.3575 13.6404 20.3575H10.3401C9.95178 20.3575 9.63702 20.0427 9.63702 19.6544C9.63702 19.266 9.95178 18.9512 10.3401 18.9512H11.2872V18.1701C10.5866 18.058 9.91956 17.7805 9.35944 17.3611C8.61584 16.8047 8.08575 16.0212 7.86676 15.1549C7.77155 14.7784 7.99951 14.3961 8.37598 14.3009C8.75244 14.2057 9.13495 14.4338 9.22998 14.8103C9.52441 15.9749 10.6853 16.8199 11.9903 16.8199C13.2953 16.8199 14.4562 15.9749 14.7506 14.8103C14.8456 14.4338 15.2278 14.2057 15.6046 14.3009C15.9811 14.3959 16.209 14.7784 16.1138 15.1549Z"
                              //               fill="#EA7804"
                              //             />
                              //             <path
                              //               d="M11.9903 14.5762C12.4334 14.5762 12.7939 14.2156 12.7939 13.7725V10.4462C12.7939 10.0031 12.4334 9.64258 11.9903 9.64258C11.5472 9.64258 11.1866 10.0031 11.1866 10.4462V13.7725C11.1866 14.2156 11.5472 14.5762 11.9903 14.5762Z"
                              //               fill="#EA7804"
                              //             />
                              //             <path
                              //               d="M21.0844 4.59406L16.9025 0.412109V4.59406H21.0844Z"
                              //               fill="#EA7804"
                              //             />
                              //           </g>
                              //           <defs>
                              //             <clipPath id="clip0_2221_16481">
                              //               <rect
                              //                 width="24"
                              //                 height="24"
                              //                 fill="white"
                              //               />
                              //             </clipPath>
                              //           </defs>
                              //         </svg>
                              //       </SvgIcon>
                              //     </Box>
                              //     <Box
                              //       sx={{
                              //         position: 'relative',
                              //         width: '100%',
                              //         height: '244px',
                              //         backgroundColor: '#fff'
                              //       }}
                              //     >
                              //       <Box
                              //         sx={{
                              //           position: 'absolute',
                              //           bottom: '46px',
                              //           left: '12px',

                              //           color: '#4E565F',
                              //           padding: '2px 6px',
                              //           borderRadius: '4px',
                              //           fontSize: '14px',
                              //           width: '42px',
                              //           height: '22px',
                              //           fontWeight: '700',
                              //           textAlign: 'center',
                              //           alignContent: 'center'
                              //         }}
                              //       >
                              //         00.00
                              //       </Box>
                              //       <img
                              //         src={defaultAudioSvg}
                              //         alt="Audio thumbnail"
                              //         style={{
                              //           width: '100%',
                              //           height: '100%',

                              //           borderTopLeftRadius: '8px',
                              //           borderTopRightRadius: '8px'
                              //         }}
                              //       />
                              //       <Box
                              //         sx={{
                              //           position: 'absolute',
                              //           bottom: '46px',
                              //           right: '12px',

                              //           color: '#4E565F',
                              //           padding: '2px 6px',
                              //           borderRadius: '4px',
                              //           fontSize: '14px',
                              //           width: '42px',
                              //           height: '22px',
                              //           fontWeight: '700',
                              //           textAlign: 'center',
                              //           alignContent: 'center'
                              //         }}
                              //       >
                              //         {fileDuration}
                              //       </Box>
                              //     </Box>
                              //   </>
                              // )
                              <Typography variant="body2" color="error">
                                Unsupported file type
                              </Typography>
                            )}
                          </Box>

                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              fontFamily: 'Lato',
                              fontSize: '16px',
                              lineHeight: '20px',
                              marginTop: '12px',
                              whiteSpace: 'normal',
                              wordBreak: 'break-word'
                            }}
                          >
                            {formik?.values?.contentTitle}
                          </Typography>
                        </Card>
                      </Box>
                    </>
                  )}

                {fileType == 'Video' && (
                  <AddQuizInVideo
                    contentId={contentId}
                    saveDisabled={isSaveDisabled}
                    formikData={formik?.values}
                    fileType={fileType}
                    fileDuration={fileDuration}
                    file={file}
                    thumbnailFile={thumbnailFile}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {initialValues?.tabValue === 1 &&
        responseInteractionMenu.map(item => {
          return (
            <Box key={item?.id} borderRadius={5} marginBottom={1}>
              <Accordion bgcolor={'white'} expanded={false} elevation={0}>
                <AccordionSummary
                  aria-controls={`panel-${item.id}-content`}
                  id={`panel-${item.id}-header`}
                  sx={{ height: 58, borderRadius: '8px' }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      margin: '7px 0px'
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={'700'}
                      fontSize={'20px'}
                    >
                      {item.menuName}
                    </Typography>
                    <Box sx={{}}>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            checked={Boolean(formik.values[item.field])}
                            onChange={e => {
                              e.stopPropagation();
                              handleResponsesSwitchChange(item.id);
                            }}
                            onClick={e => e.stopPropagation()}
                          />
                        }
                      />
                    </Box>
                  </Box>
                </AccordionSummary>
              </Accordion>
            </Box>
          );
        })}

      {initialValues?.tabValue === 2 && (
        <>
          <Box borderRadius={5} marginBottom={2}>
            <Accordion
              bgcolor={'white'}
              expanded={formik?.values?.allowPoints}
              elevation={0}
            >
              <AccordionSummary sx={{ height: 58, borderRadius: '8px' }}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    margin: '7px 0px'
                  }}
                >
                  <Typography
                    variant="body1"
                    fontSize={'20px'}
                    fontWeight={'700'}
                    color={colorTextBlack}
                  >
                    Gamification
                  </Typography>
                  <Box sx={{}}>
                    <FormControlLabel
                      sx={{
                        marginRight: '12px',
                        '& .MuiFormControlLabel-label': {
                          color: '#4E565F', // Change the text color
                          fontSize: '16px', // Change the font size
                          fontWeight: '700', // Make the text bold
                          marginRight: '8px'
                        }
                      }}
                      label="Allow points"
                      labelPlacement="start"
                      aria-expanded
                      control={
                        <IOSSwitch
                          checked={formik.values?.allowPoints}
                          onChange={() => {
                            formik.setFieldValue(
                              'allowPoints',
                              !formik.values?.allowPoints
                            );
                          }}
                          onClick={e => e.stopPropagation()}
                        />
                      }
                    />
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2} style={{ marginTop: '-30px' }}>
                  <Grid lg={3} item>
                    <InputLabel
                      required={gamificationData?.likes || false}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Points per like
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik.values?.pointsPerLike}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('pointsPerLike', newValue);
                        }}
                        disableClearable
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        getOptionLabel={option => option || ''}
                        options={['5', '10', '15', '20']}
                        renderInput={params => (
                          <TextField
                            name="pointsPerLike"
                            {...params}
                            placeholder="Select points per like"
                            error={
                              formik.touched?.pointsPerLike &&
                              Boolean(formik.errors?.pointsPerLike)
                            }
                            helperText={
                              formik.touched?.pointsPerLike &&
                              formik.errors?.pointsPerLike
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid lg={3} item>
                    <InputLabel
                      required={gamificationData?.comments || false}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Points per comment
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik.values?.pointsPerComment}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('pointsPerComment', newValue);
                        }}
                        disableClearable
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        getOptionLabel={option => option || ''}
                        options={['5', '10', '15', '20']}
                        renderInput={params => (
                          <TextField
                            name="pointsPerComment"
                            {...params}
                            placeholder="Select points per comment"
                            error={
                              formik.touched?.pointsPerComment &&
                              Boolean(formik.errors?.pointsPerComment)
                            }
                            helperText={
                              formik.touched?.pointsPerComment &&
                              formik.errors?.pointsPerComment
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid lg={3} item>
                    <InputLabel
                      required={gamificationData?.download || false}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Points per download
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik.values?.pointsPerDownload}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('pointsPerDownload', newValue);
                        }}
                        disableClearable
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        getOptionLabel={option => option || ''}
                        options={['5', '10', '15', '20']}
                        renderInput={params => (
                          <TextField
                            name="pointsPerDownload"
                            {...params}
                            placeholder="Select points per download"
                            error={
                              formik.touched?.pointsPerDownload &&
                              Boolean(formik.errors?.pointsPerDownload)
                            }
                            helperText={
                              formik.touched?.pointsPerDownload &&
                              formik.errors?.pointsPerDownload
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid lg={3} item>
                    <InputLabel
                      required={gamificationData?.share || false}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Points per share
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik.values?.pointsPerShare}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('pointsPerShare', newValue);
                        }}
                        disableClearable
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        getOptionLabel={option => option || ''}
                        options={['5', '10', '15', '20']}
                        renderInput={params => (
                          <TextField
                            name="pointsPerShare"
                            {...params}
                            placeholder="Select points per share"
                            error={
                              formik.touched?.pointsPerShare &&
                              Boolean(formik.errors?.pointsPerShare)
                            }
                            helperText={
                              formik.touched?.pointsPerShare &&
                              formik.errors?.pointsPerShare
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box borderRadius={5} marginBottom={1} bgcolor={'white'}>
            <Typography
              variant="body1"
              fontSize={'20px'}
              fontWeight={'700'}
              color={colorTextBlack}
              marginX={2}
              marginBottom={0.5}
              paddingTop={2}
            >
              Notification
            </Typography>

            <CustomAccordion
              title="Notify all users in the relevant grade"
              checked={formik?.values?.notifyAllRelevantUserByGrade}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllRelevantUserByGrade',
                  !formik?.values?.notifyAllRelevantUserByGrade
                );
              }}
            />
            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all students"
              checked={formik?.values?.notifyAllStudents}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllStudents',
                  !formik?.values?.notifyAllStudents
                );
              }}
            />

            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all teachers"
              checked={formik?.values?.notifyAllTeachers}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllTeachers',
                  !formik?.values?.notifyAllTeachers
                );
              }}
            />

            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all users in the system"
              checked={formik?.values?.notifyAllUserInSystem}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllUserInSystem',
                  !formik?.values?.notifyAllUserInSystem
                );
              }}
            />
          </Box>
        </>
      )}

      <Box bgcolor={'white'} padding={2} borderRadius={'8px'} marginTop={2}>
        <Grid display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => {
              localStorage.removeItem('localContentId');
              setContentId('');
              setInitalValues({
                ...initialValues,
                tabValue: 0
              });
              dispatch(revertAllAddContentData());
              navigate('/content-management');
            }}
            sx={{
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>

          <LoadingButton
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();

              console.log('=== Save & Next Button Clicked ===');
              console.log('Event:', e);
              console.log('Current tab:', initialValues?.tabValue);
              console.log('isSaveDisabled:', isSaveDisabled);

              if (!isSaveDisabled) {
                console.log(
                  'Processing click for tab:',
                  initialValues?.tabValue
                );

                if (initialValues?.tabValue === 0) {
                  // For tab 0, use normal formik validation
                  console.log('Using normal formik validation for tab 0');
                  formik.handleSubmit();
                } else if (initialValues?.tabValue === 1) {
                  const activeContentId = getEffectiveContentId();
                  const payload = {
                    likes: formik?.values?.likes,
                    likesContentType: 'All',
                    comments: formik?.values?.comments,
                    commentsContentType: 'All',
                    share: formik?.values?.share,
                    shareContentType: 'All',
                    download: formik?.values?.download,
                    downloadContentType: 'All',
                    loggedInUserName: authData?.userName
                  };
                  dispatch(
                    updateContentResponses({
                      payload,
                      contentId: activeContentId
                    })
                  );
                } else if (initialValues?.tabValue === 2) {
                  const activeContentId = getEffectiveContentId();
                  const payload = {
                    allowPoints: formik?.values?.allowPoints,
                    likesPoints: formik?.values?.pointsPerLike,
                    sharePoints: formik?.values?.pointsPerShare,
                    commentPoints: formik?.values?.pointsPerComment,
                    downloadPoints: formik?.values?.pointsPerDownload,
                    notifyAllRelevantUserByGrade:
                      formik?.values?.notifyAllRelevantUserByGrade,
                    notifyAllUserInSystem:
                      formik?.values?.notifyAllUserInSystem,
                    notifyAllTeachers: formik?.values?.notifyAllTeachers,
                    notifyAllStudents: formik?.values?.notifyAllStudents,
                    loggedInUserName: authData?.userName
                  };
                  dispatch(
                    updateContentSettings({
                      payload,
                      contentId: activeContentId
                    })
                  );
                }
              } else {
                console.log('Button is disabled, not proceeding');
              }
            }}
            disabled={isSaveDisabled}
            type="submit"
            variant="contained"
            style={{
              height: '42px',
              width: '110px'
            }}
            loading={
              initialValues?.tabValue < 1
                ? location.pathname === '/content-management/edit-content'
                  ? isUpadteContentLoading
                  : isAddNewContentLoading
                : initialValues.tabValue < 2
                  ? isUpadteContentResponsesLoading
                  : isUpadteContentSettingsLoading
            }
          >
            {initialValues?.tabValue < 2 ? 'Save & Next' : 'Save'}
          </LoadingButton>
        </Grid>
      </Box>

      <AddNewTagModal
        open={isNewTagModalOpen}
        handleClose={handleCloseNewTagModal}
      />

      <AddNewMediumModal
        open={isNewMediumModalOpen}
        handleClose={handleCloseNewMediumModal}
      />

      <AddNewSectionModal
        open={isNewSectionModalOpen}
        handleClose={handleCloseNewSectionModal}
      />

      {/* Preview modal*/}
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px'
          },
          '& .MuiDialog-paperWidthSm': {
            maxWidth: '702px'
          }
        }}
        open={isPreviewOpen}
        onClose={() => {
          setIsPreviewOpen(false);
        }}
      >
        <Card
          sx={{
            boxShadow: 'none',
            border: 'none',
            padding: '24px',
            overflowY: 'auto'
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '622px',
              height: '363px',
              backgroundColor: '#fff',
              overflow: 'hidden',

              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            {fileType === 'Image' ? (
              <img
                src={
                  location.pathname === '/content-management/edit-content'
                    ? file
                    : previewUrl
                }
                alt="Image thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '12px'
                }}
              />
            ) : fileType === 'PDF' ? (
              <img
                src={previewUrl}
                alt="PDF file thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '12px'
                }}
              />
            ) : fileType === 'EXCEL' ? (
              <img
                src={defaultExcelSvg}
                alt="Excel file thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '12px'
                }}
              />
            ) : fileType === 'MSWORD' ? (
              <img
                src={defaultWordSvg}
                alt="Word file thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '12px'
                }}
              />
            ) : fileType === 'Audio' ? (
              <>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '72px',
                    left: '16px',

                    color: '#4E565F',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    width: '42px',
                    height: '22px',
                    fontWeight: '700',
                    textAlign: 'center',
                    alignContent: 'center'
                  }}
                >
                  00.00
                </Box>
                <img
                  src={defaultAudioSvg}
                  alt="Audio thumbnail"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: '12px'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '72px',
                    right: '16px',

                    color: '#4E565F',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    width: '42px',
                    height: '22px',
                    fontWeight: '700',
                    textAlign: 'center',
                    alignContent: 'center'
                  }}
                >
                  {fileDuration || '00.00'}
                </Box>
              </>
            ) : fileType === 'POWERPOINT' ? (
              <img
                src={defaultPowerPointSvg}
                alt="PowerPoint thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '12px'
                }}
              />
            ) : fileType === 'Video' ? (
              <>
                <img
                  src={
                    location.pathname === '/content-management/edit-content'
                      ? thumbnailFile
                      : previewUrl
                  }
                  alt="Video thumbnail"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '12px'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '8px',
                    right: '8px',
                    backgroundColor: '#1F2933',
                    color: '#fff',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: '600',
                    opacity: 0.8
                  }}
                >
                  {fileDuration}
                </Box>
              </>
            ) : (
              <Typography variant="body2" color="error">
                Unsupported file type
              </Typography>
            )}
          </Box>

          <CardContent>
            <Typography
              fontWeight={'700'}
              size={'24px'}
              color={colorTextBlack}
              marginBottom={'8px'}
            >
              {formik?.values?.contentTitle}
            </Typography>
            <Box marginBottom={'8px'}>
              <Button
                variant="outlined"
                sx={{
                  px: 4,
                  borderColor: colorPrimary,
                  cursor: 'default',
                  fontSize: '12px',
                  fontWeight: 700,
                  marginRight: '16px',
                  borderRadius: '8px',
                  color: 'black',
                  borderWidth: '2px',
                  height: '34px',
                  width: '122px',
                  '&:hover': {
                    borderColor: colorPrimary,
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    borderWidth: '2px'
                  }
                }}
                startIcon={
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.75 12.75H2.25M11 6.91667L7.5 10.4167M7.5 10.4167L4 6.91667M7.5 10.4167V2.25"
                      stroke="#1F2933"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
              >
                Download
              </Button>
              <Button
                variant="outlined"
                sx={{
                  px: 4,
                  borderColor: colorPrimary,
                  cursor: 'default',
                  fontSize: '12px',
                  fontWeight: 700,
                  marginRight: '16px',
                  borderRadius: '8px',
                  color: 'black',
                  borderWidth: '2px',
                  height: '34px',
                  width: '97px',
                  '&:hover': {
                    borderColor: colorPrimary,
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    borderWidth: '2px'
                  }
                }}
                startIcon={
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.6283 6.85461C11.7707 6.73255 11.8419 6.67152 11.868 6.5989C11.8909 6.53515 11.8909 6.46543 11.868 6.40169C11.8419 6.32906 11.7707 6.26803 11.6283 6.14597L6.68704 1.91061C6.4419 1.70049 6.31934 1.59544 6.21557 1.59286C6.12538 1.59063 6.03924 1.63025 5.98225 1.70018C5.91667 1.78064 5.91667 1.94207 5.91667 2.26493V4.77049C4.67144 4.98834 3.53176 5.61932 2.68483 6.56671C1.76148 7.59959 1.25072 8.93626 1.25 10.3217V10.6787C1.86212 9.9413 2.62638 9.34493 3.49044 8.93041C4.25224 8.56496 5.07574 8.34848 5.91667 8.29143V10.7357C5.91667 11.0585 5.91667 11.2199 5.98225 11.3004C6.03924 11.3703 6.12538 11.41 6.21557 11.4077C6.31934 11.4051 6.4419 11.3001 6.68704 11.09L11.6283 6.85461Z"
                      stroke="#1F2933"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
              >
                Share
              </Button>
              <IconButton
                sx={{
                  width: '46px',
                  height: '34px',
                  border: 'solid #F4C24A 2px',
                  borderRadius: '8px',
                  color: '#1F2933',
                  cursor: 'default',
                  '&:hover': {
                    borderColor: colorPrimary,
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    borderWidth: '2px'
                  }
                }}
              >
                <MoreHoriz />
              </IconButton>
            </Box>
            <Typography fontWeight={'500'} size={'14px'} color={colorLinkGrey}>
              {formik?.values?.contentDescription}
            </Typography>
          </CardContent>
          <CardActions>
            <Grid display={'flex'} gap={2} marginLeft={1}>
              <Button
                variant="outlined"
                onClick={() => {
                  setIsPreviewOpen(false);
                }}
                sx={{
                  borderColor: colorPrimary,
                  borderRadius: '10px',
                  color: colorTextBlack,
                  borderWidth: '2px',
                  height: '42px',
                  width: '106px',
                  '&:hover': {
                    borderColor: colorPrimary,
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    borderWidth: '2px'
                  }
                }}
              >
                Cancel
              </Button>
              <LoadingButton
                onClick={handlePublishButtonClick}
                disabled={isSaveDisabled}
                type="submit"
                variant="contained"
                style={{
                  height: '42px',
                  width: '110px'
                }}
              >
                {contentStatus === 'Saved' ? 'Publish' : 'Unpublish'}
              </LoadingButton>
            </Grid>
          </CardActions>
        </Card>
        {/* </Grid> */}
      </Dialog>

      {isNewQuestionModalOpen && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }}
        >
          <AddNewQuestions
            handleClose={handleCloseNewQuestionModal}
            handleSubmit={handleAddQuestion}
            handleUpdate={handleUpdateQuestions}
            data={editQuestionData}
            contentId={getEffectiveContentId()}
          />
        </div>
      )}

      {!isAddNewTagLoading && isAddNewTagSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addTagResponse?.message)}
        />
      )}

      {!isAddNewTagLoading && isAddNewTagFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewTagErrorContainer?.errorMessage)}
        />
      )}

      {!isAddNewSectionLoading && isAddNewSectionSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addSectionResponse?.message)}
        />
      )}

      {!isAddNewSectionLoading && isAddNewSectionFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewSectionErrorContainer?.errorMessage)}
        />
      )}

      {!isAddNewMediumLoading && isAddNewMediumSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addMediumResponse?.message)}
        />
      )}

      {!isAddNewMediumLoading && isAddNewMediumFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewMediumErrorContainer?.errorMessage)}
        />
      )}

      {showError && (
        <SnackBarBox type="error" message={handleError(showErrorMessage)} />
      )}

      {showSuccessNotification && (
        <SnackBarBox type="success" message={successMessage} />
      )}

      {!isAddNewContentLoading && isAddNewContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addContentResponse?.payload?.message)}
        />
      )}

      {!isAddNewContentLoading && isAddNewContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewContentErrorContainer?.errorMessage)}
        />
      )}

      {!isUpadteContentLoading && isUpadteContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(upadteContentErrorContainer?.errorMessage)}
        />
      )}

      {!isUpadteContentLoading && isUpadteContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError('Content updated successfully.')}
        />
      )}

      {!isSaveFlashCardLoading && isSaveFlashCardSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(flashCardResponse?.message)}
        />
      )}

      {!isSaveFlashCardLoading && isSaveFlashCardFailed && (
        <SnackBarBox
          type="error"
          message={handleError(flashCardErrorContainer?.errorMessage)}
        />
      )}

      {!isDeleteQuestionLoading && isDeleteQuestionSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(deleteQuestionResponse?.message)}
        />
      )}

      {!isDeleteQuestionLoading && isDeleteQuestionFailed && (
        <SnackBarBox
          type="error"
          message={handleError(deleteQuestionErrorContainer?.errorMessage)}
        />
      )}

      {!isPublishContentLoading && isPublishContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(publishContentResponse?.message)}
        />
      )}

      {!isUpadteContentSettingsLoading && isUpadteContentSettingsSuccess && (
        <SnackBarBox
          type="success"
          message={updateContentSettingsResponse?.message}
        />
      )}

      {!isAddNewQuizLoading && isAddNewQuizSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addNewQuizResponse?.message)}
        />
      )}

      {!isAddNewQuizLoading && isAddNewQuizFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewQuizErrorContainer?.errorMessage)}
        />
      )}

      {!isDeleteQuizLoading && isDeleteQuizSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(deleteQuizResponse?.message)}
        />
      )}

      {!isDeleteQuizLoading && isDeleteQuizFailed && (
        <SnackBarBox
          type="error"
          message={handleError(deleteQuizErrorContainer?.errorMessage)}
        />
      )}

      <ConfirmBox
        isOpen={isDeleteModalOpen}
        title="Delete question!"
        subtitle={`Are you sure you want to delete question.`}
        handleClose={handleCloseDeleteModal}
        handleSubmit={handleDeleteQuestion}
      />
    </>
  );
};

export default AddNewContents;
